/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
/* eslint-disable prefer-arrow-callback */

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Theme,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import {
  ArrowDownward,
  ArrowDropDown,
  ArrowRight,
  ArrowRightAlt,
  CallEnd,
  CallEndOutlined,
  CallMade,
  CallMissed,
  CallRounded,
  GetApp,
  HowToReg,
  HowToRegOutlined,
  LocalParking,
  LocalParkingOutlined,
  NotificationsActive,
  NotificationsActiveOutlined,
  People,
  PeopleAlt,
  PeopleAltOutlined,
  Person,
  PhoneDisabled,
  PhoneDisabledOutlined,
  PhoneForwarded,
  PhoneForwardedOutlined,
  PhoneInTalk,
  PhoneInTalkOutlined,
  PhoneMissed,
  PhoneMissedOutlined,
  PhonePaused,
  PhonePausedOutlined,
  PictureAsPdf,
  Print,
  PrintOutlined,
  Settings,
  SettingsOutlined,
  SettingsVoice,
  SettingsVoiceOutlined,
  Voicemail,
  VoicemailOutlined,
  ZoomIn,
  ZoomOut,
} from "@material-ui/icons";
import React, {
  SetStateAction,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import pdfMake, { fonts } from "pdfmake/build/pdfmake";
import CxAgent from "../CxAgent";
import { CXAgent } from "../CxDashboard";
import {
  FormatEXCallEvents,
  FormatCXCallEvents,
  CallEvent,
  CxCallEvent,
  reasonRenderer,
} from "./C2Gfunctions";

const handleMouseMove = (
  e: any,
  setMouseXCoord: React.Dispatch<SetStateAction<number | undefined>>
) => {
  const xCoord = e.pageX - e.currentTarget.getBoundingClientRect().left;
  setTimeout(() => {
    setMouseXCoord(xCoord);
  }, 1);
};

function formatTimeDifference(startTime: any, endTime: any) {
  const differenceInMs = endTime - startTime;
  const totalSeconds = Math.floor(differenceInMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;  
  if (formattedTime === "NaN:NaN") return "--"
  return formattedTime;
}

const HandlePlatformTransferLabels = ({
  timeStamps,
  EXEvents,
  CXEvents,
  cxTransfersFromEx,
  cxTransfersToEx,
  exTransferFromCx,
  exTransferToCx, 
  granularity,
  mode
} : {
  timeStamps: number[],
  EXEvents: Map<string, CallEvent[]>,
  CXEvents: Map<string, CxCallEvent[]>,
  cxTransfersFromEx: Map<string, CallEvent[]>
  cxTransfersToEx: Map<string, CallEvent[]>,
  exTransferToCx: Map<string, CxCallEvent[]>
  exTransferFromCx: Map<string, CxCallEvent[]>
  granularity: number,
  mode: string
}) => {
 if (timeStamps) {
  // console.log('cx transfers from EX: ', cxTransfersFromEx, '\ncx transfers to EX: ', cxTransfersToEx, '\nex transfers from CX: ', exTransferFromCx, '\nex transfers to CX: ', exTransferToCx)
  if (exTransferToCx.size > 0) {
    const firstInstance = Array.from(exTransferToCx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.timeStamp) < new Date(b?.timeStamp) ? a : b)
    const lastInstance = Array.from(exTransferToCx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.timeStamp) > new Date(b?.timeStamp) ? a : b)
    const timeZoneOffset_firstInstance = new Date(firstInstance.timeStamp)?.getTimezoneOffset() * 60 * 1000;
    const timeZoneOffset_lastInstance = new Date(lastInstance.timeStamp)?.getTimezoneOffset() * 60 * 1000;
    const firstInstanceNormalized = new Date(firstInstance.timeStamp).getTime() + timeZoneOffset_firstInstance;
    const lastInstanceNormalized = new Date(lastInstance.timeStamp).getTime() + timeZoneOffset_lastInstance;

    const timeStampBaseline = timeStamps[1] - timeStamps[0];
    const leftPosition = ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity;
    const widthPosition = ((lastInstanceNormalized - firstInstanceNormalized) / 100) * granularity + 20;

    // console.log('timestamp baseline', (timeStampBaseline / 100) * granularity, ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity)

    return <div className="transfer-header-display cx-transfer-header" style={{color: 'white' , zIndex: 2, position: 'absolute', width: widthPosition, left: leftPosition, background: mode === 'light' ? "#c46916b5" :  "#ff7a0070", border: '1px solid #ff7a0047', padding: '0px 2px', borderRadius: 5, display: 'flex', alignItems: 'center', fontSize: '0.8em', marginTop: 4}} ><PhoneForwarded style={{color: mode === 'light' ? "black" : 'white', fontSize: '1em'}} /> CX</div>
  }
 }
 if (exTransferFromCx.size > 0) {
  const firstInstance = Array.from(exTransferFromCx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.timeStamp) < new Date(b?.timeStamp) ? a : b)
  const lastInstance = Array.from(exTransferFromCx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.timeStamp) > new Date(b?.timeStamp) ? a : b)
  const timeZoneOffset_firstInstance = new Date(firstInstance.timeStamp)?.getTimezoneOffset() * 60 * 1000;
  const timeZoneOffset_lastInstance = new Date(lastInstance.timeStamp)?.getTimezoneOffset() * 60 * 1000;
  const firstInstanceNormalized = new Date(firstInstance.timeStamp).getTime() + timeZoneOffset_firstInstance;
  const lastInstanceNormalized = new Date(lastInstance.timeStamp).getTime() + timeZoneOffset_lastInstance;

  const timeStampBaseline = timeStamps[1] - timeStamps[0];
  const leftPosition = ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity;
  const widthPosition = ((lastInstanceNormalized - firstInstanceNormalized) / 100) * granularity + 20;

  // console.log('timestamp baseline', (timeStampBaseline / 100) * granularity, ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity)

  return <div className="transfer-header-display cx-transfer-header" style={{color: 'white' , zIndex: 2, position: 'absolute', width: widthPosition, left: leftPosition, background: mode === 'light' ? "#c46916b5" :  "#ff7a0070", border: '1px solid #ff7a0047', padding: '0px 2px', borderRadius: 5, display: 'flex', alignItems: 'center', fontSize: '0.8em', marginTop: 4}} ><PhoneForwarded style={{color: 'white', fontSize: '1em'}} /> CX</div>
}

// blue transfer bars
if (cxTransfersToEx.size > 0) {
  const firstInstance = Array.from(cxTransfersToEx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.body.eventTime) < new Date(b?.body.eventTime) ? a : b)
  const lastInstance = Array.from(cxTransfersToEx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.body.eventTime) > new Date(b?.body.eventTime) ? a : b)
  const firstInstanceNormalized = new Date(firstInstance.body.eventTime).getTime();
  const lastInstanceNormalized = new Date(lastInstance.body.eventTime).getTime();
  const leftPosition = ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity;
  const widthPosition = ((lastInstanceNormalized - firstInstanceNormalized) / 100) * granularity + 20;

  return <div style={{color: 'white' , zIndex: 2, position: 'absolute', width: widthPosition, left: leftPosition, background: mode === 'light' ? "#0c89deb3" : "#0066ac91", border: '1px solid #0173c1', padding: '0px 2px', borderRadius: 5, display: 'flex', alignItems: 'center', fontSize: '0.8em', marginTop: 4}} ><PhoneForwarded style={{color: 'white', fontSize: '1em'}} /> EX</div>

}

if (cxTransfersFromEx.size > 0) {
  const firstInstance = Array.from(cxTransfersFromEx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.body.eventTime) < new Date(b?.body.eventTime) ? a : b)
  const lastInstance = Array.from(cxTransfersFromEx.entries())?.map((t) => t[1])?.flat()?.reduce((a,b) => new Date(a?.body.eventTime) > new Date(b?.body.eventTime) ? a : b)
  const firstInstanceNormalized = new Date(firstInstance.body.eventTime).getTime();
  const lastInstanceNormalized = new Date(lastInstance.body.eventTime).getTime();
  const leftPosition = ((firstInstanceNormalized - timeStamps[0]) / 100) * granularity;
  const widthPosition = ((lastInstanceNormalized - firstInstanceNormalized) / 100) * granularity + 20;

  return <div style={{color: 'white' , zIndex: 2, position: 'absolute', width: widthPosition, left: leftPosition, background: mode === 'light' ? "#0c89deb3" : "#0066ac91", border: '1px solid #0173c1', padding: '0px 2px', borderRadius: 5, display: 'flex', alignItems: 'center', fontSize: '0.8em', marginTop: 4}} ><PhoneForwarded style={{color: 'white', fontSize: '1em'}} /> EX</div>

}

 return <></>
}

const formatDuration = (time: number) => {
  if (time <= 0) {
    return " ";
  }
  const durationSeconds = time;
  const durationMinutes = Math.floor(durationSeconds / 60);
  const durationHours =
    durationMinutes >= 60 ? Math.floor(durationMinutes / 60) : "";
  const seconds = durationSeconds % 60;
  const minutes = durationMinutes % 60;
  return durationHours !== ""
    ? `(${durationHours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")})`
    : `(${durationMinutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")})`;
};

const RenderCxLeg = memo(function RenderCXLeg({
  event,
  eventArr,
  index,
  cxAgents,
  mode,
  setExpanded,
  deviceId,
}: {
  event: CxCallEvent;
  index: number;
  eventArr: CxCallEvent[];
  cxAgents: any;
  mode: string;
  setExpanded: React.Dispatch<SetStateAction<string | number | boolean>>;
  deviceId: string | number | boolean;
}) {
  const [hoverIndex, setHoverIndex] = useState(0);
  const renderCXIcon = () => {
    const iconStyles = {
      color: "white",
      fontSize: "1em",
    };
    if (event.type === "queue") {
      return <PeopleAlt style={iconStyles} />;
    }
    if (event.type === "agent") {
      if (event.event === "abandonTime")
        return <NotificationsActive style={iconStyles} />;
      if (
        event.event === "connectedTime" ||
        event.event === "accurate-connectedTime"
      )
        return <PhoneInTalk style={iconStyles} />;
      if (event.event === "disconnectedTime")
        return <CallEnd style={iconStyles} />;
      if (event.event === "deflected")
        return <PhoneDisabled style={iconStyles} />;
      if (event.event.includes("transfer-")) {
        return <PhoneForwarded style={iconStyles} />;
      }
      if (event.event === "noAnswerTime") {
        return <CallMissed style={iconStyles} />;
      }
    }
    return <PeopleAlt style={iconStyles} />;
  };

  const renderCXDotStyles = (e: string) => {
    if (event.type === "queue") {
      return "#ffcc00";
    }
    if (e === "abandonTime" || e === "accurate-abandonTime") {
      return "#7ccbe9";
    }
    if (e === "connectedTime" || e === "accurate-connectedTime") {
      return "#86CF6E";
    }
    if (
      event.event === "disconnectedTime" ||
      event.event === "accurate-disconnectedTime" ||
      e === "noAnswerTime"
    ) {
      return "#ff0000";
    }
    if (e === "deflectedTime") {
      return "#557799";
    }
    if (e === "transfer" || e.includes("transfer-")) {
      return "#ff8800";
    }
    return "#557799";
  };
  const renderColor = (state: string) => {
    if (state === "AVAILABLE") {
      return "#008000cc";
    }
    if (
      state === "RNA-STATE" ||
      state === "UNAVAILABLE" ||
      state === "ENGAGED" ||
      state === "BREAK-AFTER-CALL" ||
      state === "TRANSITION" ||
      state === "PENDING-DISPOSITION"
    ) {
      return "#fe2d2d";
    }
    if (
      state === "ON-BREAK" ||
      state === "OFF-LINE" ||
      state === "AWAY" ||
      state === "LUNCH" ||
      !state ||
      state === undefined ||
      state === "UNKNOWN"
    ) {
      return "gray";
    }
    if (state === "TRAINING" || state === "WORKING") {
      return "#f7b500";
    }
    return "gray";
  };
  
  const CustomTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      background:
      mode === "light" ? theme.palette.common.white : "linear-gradient(20deg, #181818, #282828)",
      color: mode === "light" ? "black" : "white",
      boxShadow: theme.shadows[1],
      fontSize: 11,
      border: "1px solid #66666666",
      zIndex: 20,
    },
    arrow: {
      "&:before": {
        border: "1px solid #66666666",
        backgroundColor:
          mode === "light" ? theme.palette.common.white : "#181818",
      },
      color: theme.palette.common.white,
    },
  }))(Tooltip);
  const selectedAgent = cxAgents.find(
    (agent: CXAgent) => agent.id === event.id
  );
  return (
    <div className="icon-box" style={{ position: "relative" }}>
      {cxAgents && (
        <CustomTooltip
          placement="top"
          arrow
          PopperProps={{
            style: {
              zIndex: 200,
            },
            disablePortal: true,
          }}
          title={
            <div
            style={{
              minWidth: 230,
              maxWidth: 280,
              zIndex: 1,
              position: "relative",
              padding: 5,
            }}
          >
            <div style={{position: 'absolute', right: 0, top: 2, border: '1px solid rgba(255, 122, 0, 0.28)', borderRadius: 5, height: 13, width: 13, padding: 2, alignItems: 'center', justifyContent: 'end', fontSize: '0.8em', background: "rgba(196, 105, 22, 0.71)", color: 'white'}}>CX</div>
              <div style={{display: 'flex', justifyContent: 'start', alignItems: 'center'}}>
              {selectedAgent && (
               <>
               <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <img
                    style={{ width: 46, height: 46, borderRadius: 50 }}
                    src={event.portrait || "./default-user-image.ico"}
                      alt="profile-pic"
                    />
                    <div
                      style={{
                        position: "absolute",
                        bottom: 3,
                        left: 35,
                        width: 10,
                        height: 10,
                        borderRadius: 50,
                        border: '1px solid #ffffff55',
                        background: renderColor(
                          cxAgents?.find(
                            (agent: CXAgent) => agent.id === event.id
                          )?.agentState
                        ),
                      }}
                    />
                  </div> 
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                 <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
                   {event.username}
             </h4>
             <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
               {reasonRenderer(event.event)}{" "}
             </h4>
             <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
             {new Date(
                 new Date(event.timeStamp).getTime() + 4 * 60 * 60 * 1000
               ).toLocaleTimeString("en-US", {
                 hour: "numeric",
                 minute: "numeric",
                 second: "numeric",
                 hour12: true,
               })}{" "}
               {formatDuration(
                 ((eventArr[index + 1]
                   ? new Date(eventArr[index + 1].timeStamp).getTime()
                   : 0) -
                   new Date(event.timeStamp).getTime()) /
                   1000
               )}
             </h4>
                 </div></>
              )}
              {!selectedAgent && (
                <>
                 <div
                 style={{
                   display: "flex",
                   justifyContent: "start",
                   alignItems: "center",
                 }}
               >
                  <div
                    style={{
                      color: "white",
                      marginBottom: 5,
                      position: "relative",
                      width: 46,
                      height: 46,
                      borderRadius: 50,
                      border:
                        mode === "light"
                          ? "1px solid #eee"
                          : "1px solid #68686e",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: mode === "light" ? "#d3a901" : "",
                    }}
                  >
                    <PeopleAlt style={{ width: 20, height: 20 }} />
                  </div>
                </div>
                 <div style={{display: 'flex', flexDirection: 'column'}}>
                 <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
                   {event.queueName}
             </h4>
             <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
               {reasonRenderer(event.event)}{" "}
             </h4>
             <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
             {new Date(
                 new Date(event.timeStamp).getTime() + 4 * 60 * 60 * 1000
               ).toLocaleTimeString("en-US", {
                 hour: "numeric",
                 minute: "numeric",
                 second: "numeric",
                 hour12: true,
               })}{" "}
               {formatDuration(
                 ((eventArr[index + 1]
                   ? new Date(eventArr[index + 1].timeStamp).getTime()
                   : 0) -
                   new Date(event.timeStamp).getTime()) /
                   1000
               )}
             </h4>
                 </div>
                </>
              )}
                 
              </div>
            </div>
          }
        >
          <button
            onMouseEnter={() => setHoverIndex(100000)}
            onMouseLeave={() => setHoverIndex(0)}
            type="button"
            className="icon-parent"
            style={{
              zIndex: 4,
              width: 21,
              minWidth: 21,
              height: 21,
              background: `color-mix(in srgb, ${renderCXDotStyles(event.event)} 80%, black ${mode === 'light' ? "20%" : "80%"})`,
              borderRadius: 50,
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `2px solid ${renderCXDotStyles(event.event)}`,
              cursor: "pointer",
            }}
          >
            {renderCXIcon()}
          </button>
        </CustomTooltip>
      )}
    </div>
  );
});
const RenderEXLeg = memo(function RenderEXLeg({
  device,
  event,
  index,
  sequence,
  user,
  mode,
  queue,
  deviceId,
  setExpanded,
  hasCX
}: {
  device: CallEvent[];
  event: CallEvent;
  index: number;
  sequence: number[];
  user: any;
  mode: string;
  queue: any;
  deviceId: string | number | boolean;
  setExpanded: React.Dispatch<SetStateAction<string | number | boolean>>;
  hasCX: boolean
}) {
  const [hoverIndex, setHoverIndex] = useState(0);
  const CustomTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      background:
        mode === "light" ? theme.palette.common.white : "linear-gradient(20deg, #181818, #282828)",
      color: mode === "light" ? "black" : "white",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      border: "1px solid #66666666",
      zIndex: 20,
    },
    arrow: {
      "&:before": {
        border: "1px solid #66666666",
        backgroundColor:
          mode === "light" ? theme.palette.common.white : "#181818",
      },
      color: theme.palette.common.white,
    },
  }))(Tooltip);

  const renderColor = (state: string) => {
    if (state.startsWith("AVL")) return "#008000cc";
    if (state.startsWith("DND")) return "#ff0000cc";
    if (state.startsWith("INV")) return "#666666cc";
    if (state.startsWith("BSY")) return "#ff0000cc";
    return "#00ff00cc";
  };

  const {to, from, direction, status} = event?.body?.parties[0];
  const {eventTime} = event.body;
  return (
    <div className="icon-box" style={{ position: "relative" }}>
      <CustomTooltip
        placement="top"
        arrow
        PopperProps={{
          style: {
            zIndex: 200,
          },
          disablePortal: true,
        }}
        title={
          <div
            style={{
              minWidth: 230,
              maxWidth: 280,
              zIndex: 1,
              position: "relative",
              padding: 5,
            }}
          >
          <div style={{position: 'absolute', right: 0, top: 2, border: "1px solid rgb(1, 115, 193)", borderRadius: 5, height: 13, width: 13, padding: 2, alignItems: 'center', justifyContent: 'end', fontSize: '0.8em', background: "rgba(0, 102, 172, 0.57)", color: 'white'}}>EX</div>
            {user && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <div style={{ position: "relative" }}>
                  <img
                    style={{ width: 46, height: 46, borderRadius: 50 }}
                    src={user.signedUrl || "./default-user-image.ico"}
                    alt="profile-pic"
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: 3,
                      left: 35,
                      width: 10,
                      height: 10,
                      borderRadius: 50,
                      background: renderColor(user.display),
                      border: '1px solid #ffffff55'
                    }}
                  />
                </div>
                <div style={{display: 'flex', flexDirection: "column"}}>
                  <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 'bolder', whiteSpace: 'nowrap'}}>
                    {user?.firstName} {user?.lastName}
                  </h4>
                  <h4 style={{marginLeft: 10, marginTop: 0, marginBottom: 0, whiteSpace:"nowrap" }}>
                    {event.body.parties[0].status.code && event.body.parties[0].status.code === "Proceeding" ? "Ringing" : event.body.parties[0].status.code}{" "}{event.body.parties[0].status.reason && `(${event.body.parties[0].status.reason})`}{" "}
                  </h4>
                  <h4 style={{margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 300, color: mode === 'light' ? "#222222" : "#ddd", whiteSpace: 'nowrap'}}>
                    {new Date(event.body.eventTime).toLocaleTimeString("en-US")}{" "}
                    {formatDuration(
                      Math.floor(
                        ((device[index]
                          ? new Date(device[index].body.eventTime).getTime()
                          : 0) -
                          new Date(event.body.eventTime).getTime()) /
                          1000
                      )
                    )}
                  </h4>
                </div>
              </div>
            )}
            {queue && (
              <div
              style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    color: "white",
                    marginBottom: 5,
                    position: "relative",
                    width: 40,
                    minWidth: 40, 
                    maxWidth: 40,
                    height: 40,
                    borderRadius: 50,
                    border:
                      mode === "light" ? "1px solid #eee" : "1px solid #68686e",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: mode === "light" ? "#d3a901" : "",
                  }}
                >
                  <PeopleAlt style={{ width: 20, height: 20 }} />
                </div>
                <div>
                <div style={{display: 'flex', flexDirection: "column"}}>
                <h4 style={{ margin: 0, marginLeft: 10, textAlign: "start", fontWeight: 900}}>
                  {queue.name} 
                </h4>  
                <h4 style={{ textAlign: "start", marginLeft: 10, marginTop: 0, marginBottom: 0, whiteSpace: 'nowrap' }}>
                  {event.body.parties[0].status.code &&
                  event.body.parties[0].status.code === "Proceeding"
                    ? "Ringing"
                    : event.body.parties[0].status.code}{" "}
                  {event.body.parties[0].status.reason &&
                    `(${event.body.parties[0].status.reason})`}{" "}
                    
                </h4>
                <h4  style={{ textAlign: "start",  margin: 0, marginLeft: 10,}}>
                {new Date(event.body.eventTime).toLocaleTimeString("en-US")}{" "}
                  {formatDuration(
                    Math.floor(
                      ((device[index]
                        ? new Date(device[index].body.eventTime).getTime()
                        : 0) -
                        new Date(event.body.eventTime).getTime()) /
                        1000
                    )
                  )}
                </h4>
                </div>
                </div>
              </div>
            )}
            
            <div style={{marginTop: 16}}>
            <div >
                {/* <div className="c2g-rows-box">
                  <p>Time: </p>
                  <p>
                    {new Date(eventTime).toLocaleTimeString(
                      "en-US",
                      {
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                      }
                    )}
                  </p>
                </div> */}
                <div className="c2g-rows-box">
                  <p>Direction: </p>
                  <p>{direction}</p>
                </div>
                {/* <div className="c2g-rows-box">
                  <p>status: </p>
                  <p>
                    {status.code && status.code === "Proceeding"
                      ? "Ringing"
                      : status.code}
                  </p>
                </div> */}
                {/* {status.reason && (
                  <div className="c2g-rows-box">
                    <p>reason: </p>
                    <p>{status.reason}</p>
                  </div>
                )} */}
                {from && (
                  <div className="c2g-rows-box">
                    <p>From: </p>
                    <div style={{ textAlign: "end" }}>
                      <p>{from.phoneNumber}</p>
                      <p>{from.name}</p>
                      <p>{from.extensionId}</p>
                      <p>{from.extensionNumber}</p>
                    </div>
                  </div>
                )}
                {to && (
                  <div className="c2g-rows-box">
                    <p>To: </p>
                    <div style={{ textAlign: "end" }}>
                      <p>{to.phoneNumber}</p>
                      <p>{to.name}</p>
                      <p>{to.extensionId}</p>
                      <p>{to.extensionNumber}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        }
      >
        <button
          type="button"
          onMouseEnter={() => {
            // setExpanded(deviceId);
            setHoverIndex(100000)
          }}
          onMouseLeave={() => {
            // setExpanded(false);
            setHoverIndex(0)
          }}
          className="icon-parent"
          style={{
            zIndex: 4,
            width: 21,
            minWidth: 21,
            height: 21,
            background: `color-mix(in srgb, ${renderDotStyles(
              event,
              device[index] === device[device.length]
            )} 80%, black ${mode === 'light' ? "20%" : "80%"})`,
            borderRadius: 50,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: 0,
            cursor: "pointer",
          }}
        >
          {renderIcon(device.length, event, mode, index)}
        </button>
      </CustomTooltip>
    </div>
  );
});
const renderCXBgStyles = (event: CxCallEvent) => {
  if (event.type === "queue") {
    return "#ffcc0088";
  }
  if (event.event.includes("disconnectedTime")) return "#7ccbe988";
  if (event.event.includes("connectedTime")) return "#86CF6E88";
  if (event.event.includes("abandonTime"))
    return "repeating-linear-gradient(45deg, #98f8f788, #98f8f788 4px, #00000000 4px, #00000000 8px)";
  if (event.event.includes("disconnectedTime")) return "#7ccbe988";
  return "#999";
};
const renderDotStyles = (event: CallEvent, isEnd: boolean) => {
  const currentStatus = event.body.parties[0];
  if (currentStatus?.ivr) {
    if (isEnd) return "red";
    return "#7ccbe9";
  }
  if (currentStatus?.queue) {
    if (currentStatus.status.reason === "AgentAnswered") return "#d3a901";
    if (currentStatus.status.reason === "CallerDropped") return "#ff0000";

    return "#d3a901";
  }
  if (currentStatus?.user) {
    if (currentStatus.status.code === "Setup") return "#667788";
    if (currentStatus.status.code === "Proceeding") return "#7ccbe9";
    if (currentStatus.status.code === "Answered") return "#86CF6E";
    if (currentStatus.status.code === "Disconnected") {
      if (currentStatus.status.reason === "BlindTransfer") return "#ff8800";
      if (currentStatus.status?.reason === "CallerInputRedirect")
        return "#445566";
      return "#ff0000";
    }
    if (currentStatus.status.code === "Hold") return "#c59c0e";
    if (currentStatus.status.code === "Gone") return "#ff0000";
    if (currentStatus.status.code === "Voicemail") return "#ff8800";
    if (currentStatus.status.code === "Parked") return "#E9E57C";
    if (currentStatus.status.code === "FaxReceive") return "#5b5577";

    return "#86CF6E";
  }
  return "#999";
};
const renderBgStyles = (event: CallEvent) => {
  const currentStatus = event.body.parties[0];
  if (currentStatus?.ivr) {
    if (currentStatus.status?.code === "Disconnected") return "#00000000";
    return "#7ccbe988";
  }
  if (currentStatus?.queue) {
    if (currentStatus.status?.code === "Proceeding") return "repeating-linear-gradient(45deg, #98f8f788, #98f8f788 4px, #00000000 4px, #00000000 8px)";
    if (currentStatus.status?.code === "Disconnected") {
      if (currentStatus.status?.reason === "BlindTransfer") return "#ffcc0088";
      return "#ffcc0088";
    }
    return "#ffcc0088";
  }
  if (currentStatus?.user) {
    if (currentStatus.status?.reason === "CallerInputRedirect") return "#445566";
    if (currentStatus.status?.code === "Disconnected") return "#00000000";
    if (currentStatus.status?.code === "Proceeding") return "repeating-linear-gradient(45deg, #98f8f788, #98f8f788 4px, #00000000 4px, #00000000 8px)";
    if (currentStatus.status?.code === "Voicemail") return "#ff880088";
    if (currentStatus.status.code === "FaxReceive") return "#5b557788";
    if (currentStatus.status.code === 'Setup') return "repeating-linear-gradient(45deg, #678, #678 4px, #00000000 4px, #00000000 8px)";

    return "#86CF6E88";
  }
  return "#9998";
};
const renderTimeOnHover = (
  leftPosition: number,
  granularity: number,
  mode: string
) => {
  const pos = leftPosition / 10 / granularity;
  return (
    <div
      style={{
        position: "absolute",
        left: leftPosition - 10,
        fontSize: 12,
        zIndex: 101,
        top: 0,
        color: mode === "light" ? "#191919" : "white",
        background: mode === "light" ? "white" : "#191919",
        padding: "0px 5px",
        marginTop: 25,
        borderRadius: 5,
        height: 12,
      }}
    >
      {String(Math.floor(pos / 60)).padStart(2, "0")}:
      {String(Math.floor(pos % 60)).padStart(2, "0")}
    </div>
  );
};
const getTimeIncrements = (
  firstTime: number,
  secondTime: number,
  mode: string,
  granularity: number,
  focusMode: boolean
) => {
  const arrayOfTimestamps: number[] = [];
  for (let i = firstTime; i < secondTime; i += 10000) {
    arrayOfTimestamps.push(i);
  }
  return arrayOfTimestamps.map((time, i) => {
    const diff = Math.floor((time - firstTime) / 1000);
    const minutes = Math.floor(diff / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (diff % 60).toString().padStart(2, "0");
    const colorGetter = (f: boolean) => {
      if (f) {
        return mode === "light" ? "#888" : "#888";
      }
      return mode === "light" ? "#444" : "#aaa";
    };
    return (
      <div
        style={{
          position: "absolute",
          left: i * (100 * granularity),
          fontSize: 12,
          color: colorGetter(false),
          overflow: "visible",
          zIndex: 100,
          marginTop: 24,
        }}
      >
        {`${minutes}:${seconds}`}
      </div>
    );
  });
};
const handleColorFillTop = (mode: string, granularity: number) => {
  if (mode === "light") return granularity === 8 ? "gray" : "black";
  return granularity === 8 ? "gray" : "white";
};
const handleColorFillBottom = (mode: string, granularity: number) => {
  if (mode === "light") return granularity === 0.5 ? "gray" : "black";
  return granularity === 0.5 ? "gray" : "white";
};
const renderIcon = (
  length: number,
  event: CallEvent,
  mode: string,
  index: number
) => {
  const eventType = event.body.parties[0];
  const iconStyles = {
    color: mode === 'light' ? "white" : "#eee",
    fontSize: "1em",
  };
  // const iconStyleEnd = {
  //   color: `color-mix(in srgb, ${renderDotStyles(event, true)} 80%, white 20%)`,
  //   fontSize: "1em",
  // };
  if (eventType.ivr) {
    if (length === index) {
      return <CallEndOutlined style={iconStyles} />;
    }
    return <SettingsVoiceOutlined style={iconStyles} />;
  }
  if (eventType.queue) {
    if (eventType.status.reason === "AgentAnswered")
      return <HowToRegOutlined style={iconStyles} />;
    if (eventType.status.reason === "CallerDropped")
      return <PhoneMissedOutlined style={iconStyles} />;
    if (eventType.status.reason === "Voicemail")
      return <VoicemailOutlined style={iconStyles} />;
    return <PeopleAltOutlined style={iconStyles} />;
  }
  if (eventType.user) {
    if (eventType.status.code === "Setup")
      return <SettingsOutlined style={iconStyles} />;
    if (eventType.status.code === "Proceeding")
      return <NotificationsActiveOutlined style={iconStyles} />;
    if (eventType.status.code === "Answered")
      return <PhoneInTalkOutlined style={iconStyles} />;
    if (eventType.status.code === "Disconnected") {
      if (eventType.status.reason === "BlindTransfer") {
        return <PhoneForwardedOutlined style={iconStyles} />;
      }
      if (eventType.status.reason === "CallerInputRedirect") {
        return <PhoneForwardedOutlined style={iconStyles} />;
      }
      if (eventType.status.reason === "AgentDropped")
        return <PhoneMissedOutlined style={iconStyles} />;

      return <CallEndOutlined style={iconStyles} />;
    }
    if (eventType.status.code === "Hold")
      return <PhonePausedOutlined style={iconStyles} />;
    if (eventType.status.code === "Gone")
      return <PhoneDisabledOutlined style={iconStyles} />;
    if (eventType.status.code === "Voicemail")
      return <VoicemailOutlined style={iconStyles} />;
    if (eventType.status.code === "Parked")
      return <LocalParkingOutlined style={iconStyles} />;
    if (eventType.status.code === "FaxReceive")
      return <PrintOutlined style={iconStyles} />;
    return <CallRounded style={iconStyles} />;
  }
  return "green";
};

const handleChange = (
  newParam: any,
  setExpanded: React.Dispatch<SetStateAction<boolean | string | number>>,
  expanded: boolean | string | number
) => {
  if (newParam === expanded) {
    return setExpanded(false);
  }
  return setExpanded(newParam);
};

const calculateWidths = (
  eventStamps: string[],
  arrayLength: number,
  timeStamps: number[],
  granularity: number
) => {
  const startTime = timeStamps[0];
  return eventStamps.map((eventStamp) => {
    const currentTime = new Date(eventStamp).getTime();
    const result = currentTime - startTime;
    return Math.floor((result * granularity) / 100);
  });
};
const handleGranularity = (
  input: number,
  setGranularity: React.Dispatch<SetStateAction<number>>
) => {
  if (input <= 0) return setGranularity(0.5);
  if (input >= 5) return setGranularity(5);
  return setGranularity(input);
};

const renderAccordionScheme = (m: string, e: boolean | number) => {
  if (m === "light") {
    return e ? "#2196f34d" : "#2196f31c";
  }
  return e ? "#2196f34d" : "#222628";
};

const renderCXAccordionScheme = (m: string, e: boolean | number) => {
  if (m === "light") {
    return e ? "#f384214d" : "#f379211c";
  }
  return e ? "#f3a4214d" : "#282622";

};
function C2GTimeline({
  events,
  transferEvents,
  historicalUsers,
  historicalQueues,
  mode,
  cxAgents,
  orgId
}: {
  events: CallEvent[] | any;
  transferEvents: undefined | any;
  historicalUsers: any;
  historicalQueues: any;
  mode: string;
  cxAgents: any;
  orgId: string | undefined
}) {
  const [EXEvents, setEXEvents] = useState<Map<string, CallEvent[]>>(new Map());
  const [CXEvents, setCXEvents] = useState<Map<string, CxCallEvent[]>>(
    new Map()
  );
  const [timeStamps, setTimeStamps] = useState<Array<number>>([]);
  const [sequence, setSequence] = useState<number[]>([]);
  const [expanded, setExpanded] = useState<string | number | boolean>(false);
  const [granularity, setGranularity] = useState<number>(1);
  const [isCX, setIsCX] = useState<boolean>(false);
  // storing transfers for CX charts
  const [cxTransfersToEx, setCxTransfersToEx] = useState<Map<string, CallEvent[]>>(new Map());
  const [cxTransfersFromEx, setCxTransfersFromEx] = useState<Map<string, CallEvent[]>>(new Map());
  // storing transfers for EX charts
  const [exTransferToCx, setExTransferToCx] = useState<Map<string, CxCallEvent[]>>(new Map());
  const [exTransferFromCx, setExTransferFromCx] = useState<Map<string, CxCallEvent[]>>(new Map());
  const [mouseCoords, setMouseXCoord] = useState<number | undefined>();

  
  useEffect(() => {
    if (events) {
      if (!events.callData) {
        // EX Events, no transfers
        if (events && !transferEvents?.from && !transferEvents?.to) {
          setIsCX(false);
          setCXEvents(new Map());
          setEXEvents(events.reduce(
            (map: Map<string, CallEvent[]>, obj: CallEvent) => {
              const { extensionId } = obj.body.parties[0];
              const group = map.get(extensionId) || [];
              group.push(obj);
              map.set(extensionId, group);
              return map;
            },
            new Map<string, CallEvent[]>()
          ));
          setCxTransfersFromEx(new Map())
          setCxTransfersToEx(new Map())
          setExTransferFromCx(new Map())
          setExTransferToCx(new Map())
          const sorted = events.sort((event1: CallEvent, event2: CallEvent) => new Date(event1.body.eventTime).getTime() > new Date(event2.body.eventTime).getTime()? 1 : -1);
          if (sorted && sorted.length) {
            setTimeStamps([new Date(sorted[0].body.eventTime).getTime(), new Date(sorted[sorted.length - 1].body.eventTime).getTime()]);
            setSequence(() => {
              const sequenceArr: number[] = [];
              const byFirstSequenceInt = sorted.sort((event: CallEvent) =>(event?.body?.sequence || 0) - (event?.body?.sequence || 0));
              const first = byFirstSequenceInt[0].body.sequence!;
              const last = byFirstSequenceInt[byFirstSequenceInt.length - 1].body.sequence!;
              for (let i = first; i <= last; i++) sequenceArr.push(i); return sequenceArr;
            });
          }
          // console.log('case one: Pure EX, no transfer')
        }
        // Ex Events & transfers from CX (setExTransferFromCx)
        if (events && transferEvents?.from) {
          setIsCX(false);
          setCXEvents(new Map());
          setEXEvents(events.reduce(
            (map: Map<string, CallEvent[]>, obj: CallEvent) => {
              const { extensionId } = obj.body.parties[0];
              const group = map.get(extensionId) || [];
              group.push(obj);
              map.set(extensionId, group);
              return map;
            },
            new Map<string, CallEvent[]>()
          ));
          setCxTransfersFromEx(new Map())
          setCxTransfersToEx(new Map())
          setExTransferToCx(new Map())
          const sortedEXEvents = events.sort((event1: CallEvent, event2: CallEvent) => new Date(event1.body.eventTime).getTime() > new Date(event2.body.eventTime).getTime()? 1 : -1);
          setSequence(() => {
            const sequenceArr: number[] = [];
            const byFirstSequenceInt = sortedEXEvents.sort((event: CallEvent) =>(event?.body?.sequence || 0) - (event?.body?.sequence || 0));
            const first = byFirstSequenceInt[0].body.sequence!;
            const last = byFirstSequenceInt[byFirstSequenceInt.length - 1].body.sequence!;
            for (let i = first; i <= last; i++) sequenceArr.push(i); return sequenceArr;
          });
          const parsedCxEvents = FormatCXCallEvents(transferEvents.from, cxAgents);
          setExTransferFromCx(parsedCxEvents);
          const firstCxEvent = parsedCxEvents.entries().next().value!;
          const firstEventTimeStamp = new Date(firstCxEvent[1][0]?.timeStamp);
          const firstEventTimeStampFormattedWithOffset = new Date(firstEventTimeStamp).getTime() + new Date(firstEventTimeStamp).getTimezoneOffset() * 1000 * 60;
          setTimeStamps([firstEventTimeStampFormattedWithOffset, new Date(sortedEXEvents[sortedEXEvents.length - 1].body.eventTime).getTime()]);                
              
          // console.log('case two: CX with a transfer out to EX platform')
        }
        // Ex Events & transfers to CX (setExTransferToCx)
        if (events && transferEvents?.to) {
          setIsCX(false);
          setCXEvents(new Map());
          setEXEvents(events.reduce(
            (map: Map<string, CallEvent[]>, obj: CallEvent) => {
              const { extensionId } = obj.body.parties[0];
              const group = map.get(extensionId) || [];
              group.push(obj);
              map.set(extensionId, group);
              return map;
            },
            new Map<string, CallEvent[]>()
          ));
          setCxTransfersFromEx(new Map())
          setCxTransfersToEx(new Map())
          setExTransferFromCx(new Map())
          const sortedEXEvents = events.sort((event1: CallEvent, event2: CallEvent) => new Date(event1.body.eventTime).getTime() > new Date(event2.body.eventTime).getTime()? 1 : -1);
          setSequence(() => {
            const sequenceArr: number[] = [];
            const byFirstSequenceInt = sortedEXEvents.sort((event: CallEvent) =>(event?.body?.sequence || 0) - (event?.body?.sequence || 0));
            const first = byFirstSequenceInt[0].body.sequence!;
            const last = byFirstSequenceInt[byFirstSequenceInt.length - 1].body.sequence!;
            for (let i = first; i <= last; i++) sequenceArr.push(i); return sequenceArr;
          });
          const parsedCxEvents = FormatCXCallEvents(transferEvents.to, cxAgents);
          // console.log('parsed CX Events: ', Array.from(parsedCxEvents.values()).flat().reduce((a,b) => new Date(a.timeStamp).getTime() < new Date(b.timeStamp).getTime() ? a : b), 'need last timestamp')
          setExTransferToCx(parsedCxEvents);
          const lastCxEvent =  Array.from(parsedCxEvents.values()).flat().reduce((a,b) => new Date(a.timeStamp).getTime() < new Date(b.timeStamp).getTime() ? a : b);
          const lastEventTimeStamp = new Date(lastCxEvent.timeStamp);
          const lasttEventTimeStampFormattedWithOffset = new Date(lastEventTimeStamp).getTime() + new Date(lastEventTimeStamp).getTimezoneOffset() * 1000 * 60;
          setTimeStamps([new Date(sortedEXEvents[0].body.eventTime).getTime(), lasttEventTimeStampFormattedWithOffset ]);                
              
          // console.log('case three: EX platform with a transfer out to CX')
        }
      }

      // CX
      if (events.callData) {
        // CX Events, no transfers
        if (!events.toLeg && !events.fromLeg) {
          setIsCX(true)
          setEXEvents(new Map()) 
          setCXEvents(FormatCXCallEvents(events.callData, cxAgents))
          setCxTransfersFromEx(new Map())
          setCxTransfersToEx(new Map())
          setExTransferFromCx(new Map())
          setExTransferToCx(new Map())
          setTimeStamps([
            new Date(events.callData.callStart.split("#")[1]).getTime(),
            new Date(events.callData.callStart.split("#")[1]).getTime() +
              (events.callData.callEnd?.call_duration || 0) * 1000 +
              (events.callData.voicemailWaiting
                ? Number(events.callData.voicemailWaiting) * 1000
                : 0),
          ]);
          // console.log('case four: pure CX, no transfer')
        }

        // CX Events, transfers from EX (setCxTransfersFromEx)
        if (events.fromLeg) {
          setIsCX(true)
          setEXEvents(new Map()) 
          setCXEvents(FormatCXCallEvents(events.callData, cxAgents))
          setExTransferFromCx(new Map())
          setExTransferToCx(new Map())
          setCxTransfersToEx(new Map())
          const exTransferEventData = FormatEXCallEvents(events.fromLeg.callUsers);
          const newDevices = exTransferEventData.reduce((map: Map<string, CallEvent[]>, obj: CallEvent) => {
            const { extensionId } = obj.body.parties[0];
            const group = map.get(extensionId) || [];
            group.push(obj);
            map.set(extensionId, group);
            return map;
            },
            new Map<string, CallEvent[]>()
          );
          setCxTransfersFromEx(newDevices);
          const eventArr = [] as any;
          events.fromLeg.callUsers.forEach((event: any) => {
            event.events.forEach((e: CallEvent) => {
              eventArr.push(e)
            })
          })
          const sortedDates = eventArr.sort((a: CallEvent, b: CallEvent) => new Date(a.body.eventTime).getTime() > new Date(b.body.eventTime).getTime() ? 1 : -1)
          setTimeStamps([
               new Date(sortedDates[0].body.eventTime).getTime(), 
               new Date(events.callData.callStart.split("#")[1]).getTime() + (events.callData.callEnd?.call_duration || 0) * 1000 + (events.callData.voicemailWaiting? Number(events.callData.voicemailWaiting) * 1000: 0)
             ])
            //  console.log('case five: CX platform with a transfer in from EX')

        }
        // CX Events, transfers To EX (setCxTransfersToEx)
        if (events.toLeg) {
          setIsCX(true)
          setEXEvents(new Map()) 
          setCXEvents(FormatCXCallEvents(events.callData, cxAgents))
          setExTransferFromCx(new Map())
          setExTransferToCx(new Map())
          setCxTransfersFromEx(new Map())
          const exTransferEventData = FormatEXCallEvents(events.toLeg.callUsers);
          const newDevices = exTransferEventData.reduce((map: Map<string, CallEvent[]>, obj: CallEvent) => {
            const { extensionId } = obj.body.parties[0];
            const group = map.get(extensionId) || [];
            group.push(obj);
            map.set(extensionId, group);
            return map;
            },
            new Map<string, CallEvent[]>()
          );
          setCxTransfersToEx(newDevices);
          const eventArr = [] as any;
          events.toLeg.callUsers.forEach((event: any) => {
            event.events.forEach((e: CallEvent) => {
              eventArr.push(e)
            })
          })
          const sortedDates = eventArr.sort((a: CallEvent, b: CallEvent) => new Date(a.body.eventTime).getTime() > new Date(b.body.eventTime).getTime() ? 1 : -1)
          setTimeStamps([
            new Date(events.callData.callStart.split("#")[1]).getTime(),
            new Date(sortedDates[sortedDates.length -1].body.eventTime).getTime(), 
          ])
          // console.log('case six: CX platform with a transfer out to EX')
        }
      }
      // if CX
      // if (events.callData) {
      //   setExTransferFromCx(new Map())
      //   setExTransferToCx(new Map())
      //   if (!events.fromLeg) {
      //     setEXEvents(new Map());
      //     setIsCX(true);
      //     const parsedCXEvents = FormatCXCallEvents(events.callData, cxAgents);
      //     setCXEvents(parsedCXEvents);
      //     setTimeStamps([
      //       new Date(events.callData.callStart.split("#")[1]).getTime(),
      //       new Date(events.callData.callStart.split("#")[1]).getTime() +
      //         (events.callData.callEnd?.call_duration || 0) * 1000 +
      //         (events.callData.voicemailWaiting
      //           ? Number(events.callData.voicemailWaiting) * 1000
      //           : 0),
      //     ]);
      //   }
        
      // if (events.fromLeg) {
      //   setEXEvents(new Map());
      //   setIsCX(true);
      //   const parsedCXEvents = FormatCXCallEvents(events.callData, cxAgents);
      //   setCXEvents(parsedCXEvents);
      //   // console.log(events.fromLeg)
      //   const { callUsers } = events.fromLeg;
      //   const exTransferEventData = FormatEXCallEvents(callUsers);
      //   if (exTransferEventData) {
      //     const newDevices = exTransferEventData.reduce(
      //       (map: Map<string, CallEvent[]>, obj: CallEvent) => {
      //         const { extensionId } = obj.body.parties[0];
      //         const group = map.get(extensionId) || [];
      //         group.push(obj);
      //         map.set(extensionId, group);
      //         return map;
      //       },
      //       new Map<string, CallEvent[]>()
      //     );
      //     setCxTransfersFromEx(newDevices);
      //      const eventArr = [] as any;
      //     callUsers.forEach((event: any) => {
      //       event.events.forEach((e: CallEvent) => {
      //         eventArr.push(e)
      //       })
      //     })
      //     const sortedDates = eventArr.sort((a: CallEvent, b: CallEvent) => new Date(a.body.eventTime).getTime() > new Date(b.body.eventTime).getTime() ? 1 : -1)
      //     setTimeStamps([
      //        new Date(sortedDates[0].body.eventTime).getTime(), new Date(events.callData.callStart.split("#")[1]).getTime() +
      //        (events.callData.callEnd?.call_duration || 0) * 1000 +
      //        (events.callData.voicemailWaiting
      //          ? Number(events.callData.voicemailWaiting) * 1000
      //          : 0)
      //      ])
      //   }
      //   console.log('case two')

      // }
      // }
      // if CX data contains a call leg for EX to transfers [(CX) -> EX]
      // if (events.callData && events.toLeg) {
      //   const { callUsers } = events.toLeg;
      //   const exTransferEventData = FormatEXCallEvents(callUsers);
      //   if (exTransferEventData) {
      //     const newDevices = exTransferEventData.reduce(
      //       (map: Map<string, CallEvent[]>, obj: CallEvent) => {
      //         const { extensionId } = obj.body.parties[0];
      //         const group = map.get(extensionId) || [];
      //         group.push(obj);
      //         map.set(extensionId, group);
      //         return map;
      //       },
      //       new Map<string, CallEvent[]>()
      //     );
      //     setCxTransfersToEx(newDevices);
      //   }
      //   console.log('case three')

      // }
      // if EX data
      // if (!events.callData) {
      // }
      // if (events && transferEvents) {
      //   const { to, from } = transferEvents;
      //   if (to && !events.callData && !events.fromLeg) {
      //     const parsedCxEvents = FormatCXCallEvents(to, cxAgents);
      //     setExTransferToCx(parsedCxEvents);
      //     if (timeStamps) {
      //       const firstEvent = parsedCxEvents.entries()?.next()?.value;
      //       if (firstEvent) {
      //         const t = new Date(firstEvent[1][0]?.timeStamp);
      //         if (t) {
      //           const tOffset = new Date(t).getTimezoneOffset() * 1000 * 60;
      //           const totalTime = new Date(t).getTime() + tOffset;
      //           if (timeStamps && totalTime < timeStamps[0]) {
      //             setTimeStamps([totalTime, timeStamps[1]]);
      //             console.log('case five')
      //           }

      //         }
      //       }
      //     }
      //   }
      //   if (from && !events.callData && !events.fromLeg) {
      //     const parsedCxEvents = FormatCXCallEvents(from, cxAgents);
      //     setExTransferFromCx(parsedCxEvents);
      //     if (timeStamps) {
      //       const firstEvent = parsedCxEvents.entries()?.next()?.value;
      //       if (firstEvent) {
      //         const t = new Date(firstEvent[1][0]?.timeStamp);
      //         if (t) {
      //           const tOffset = new Date(t).getTimezoneOffset() * 1000 * 60;
      //           const totalTime = new Date(t).getTime() + tOffset;
      //           if (timeStamps) {
      //             setTimeStamps([totalTime, timeStamps[1]]);
      //             console.log('case six')
      //           }
      //         }
      //       }
      //     }
      //   }
      // if (!to) {
      //   setExTransferToCx(new Map());
      // }
      // if (!from) {
      //   setExTransferFromCx(new Map());
      // }
      // if (events.callData && !events.toLeg) {
      //   setCxTransfersToEx(new Map());
      // }
      // if (events.callData && !events.fromLeg) {
      //   setCxTransfersFromEx(new Map());
      // }
    // }
    }
    setExpanded(false);
  }, [events, transferEvents]);


  // useEffect(() => {
  //   if (events) {
  //     if (events.callData) {
  //       return;
  //     }
  // if (!events.callData) {
  //   const newDevices = events.reduce(
  //     (map: Map<string, CallEvent[]>, obj: CallEvent) => {
  //       const { extensionId } = obj.body.parties[0];
  //       const group = map.get(extensionId) || [];
  //       group.push(obj);
  //       map.set(extensionId, group);
  //       return map;
  //     },
  //     new Map<string, CallEvent[]>()
  //   );
  //   setEXEvents(newDevices);
  //   console.log('set new devices for case')
  //     }
  //   }
  // }, [events]);

  const MouseIndicator = memo(() => {
    return (
      <div
        style={{
          position: "absolute",
          left: mouseCoords ? mouseCoords - 2 : 0,
          top: 40,
          width: mouseCoords ? 1 : 0,
          height: "calc(100% - 40px)",
          overflow: 'hidden',
          background: mode === 'light' ? '#aaa' : '#ffffff33',
          filter: "greyscale(0.7)",
          paddingRight: 0,
          zIndex: 99999999999999,
        }}
      />
    );
  });

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setMouseXCoord(undefined);
    }, 2);
  }, []);


  const docDef = {
    header: {
      stack: [
        {text: "Cradle To Grave - EX", style: 'h1'},
        {text: `Report Time: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}` , style: 'h3'},
      ],
      margin: [40, 10]
    },
    content: [
      // {text: `Call Time: ${new Date(Array.from(EXEvents?.values())?.flat()?.[0].body?.eventTime)?.toLocaleDateString()} ${new Date(Array?.from(EXEvents?.values())?.flat()?.[0].body?.eventTime)?.toLocaleTimeString()}`, style: 'h3'},
      {
        layout: 'lightHorizontalLines',
        style: 'table', 
        table: {
          headerRows: 1,
           widths: [50, 90, 50, 35, 75, 35, 65],
           
           body: [
            [ { text: 'Details', style: 'header2' }, { text: 'To', style: 'header2' }, { text: 'From', style: 'header2' }, { text: 'Direction', style: 'header2' }, { text: 'Date', style: 'header2' }, { text: 'Duration', style: 'header2' }, { text: 'Reason', style: 'header2' } ],
            ...Array.from(EXEvents.values()).flat().sort((a,b) => (a.body.sequence || 0) - (b.body.sequence || 0))
            .filter((e) => e.body.parties[0].status.code !== 'Proceeding')
            .map((e, i, arr) => 
              [
                { 
                  text: e.body.parties[0].status.code || "--", 
                  style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", 
                  noWrap: false, 
                  margin: 0 
                }, 
                { 
                  text: 
                  e.body.parties[0].isUser ? 
                    (`${e.body.parties[0].isUser.firstName} ${e.body.parties[0].isUser.lastName}`) : 
                    (e.body.parties[0].to?.phoneNumber || e.body.parties[0].to?.extensionNumber || "--"), 
                  style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", 
                  noWrap: false,
                  margin: 0 
                }, 
                { 
                  text: e.body.parties[0].from?.name || e.body.parties[0].from?.extensionNumber || "--", 
                  style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", 
                  noWrap: false,
                  margin: 0 
                },
                { 
                  text: e.body.parties[0].direction || "--", 
                  style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", 
                  noWrap: false,
                  margin: 0 
                },
                { 
                  text: `${new Date(e.body.eventTime).toLocaleDateString()} ${new Date(e.body.eventTime).toLocaleTimeString()}`, 
                  style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", 
                  noWrap: false,
                  margin: 0
                }, 
                { text: formatTimeDifference(new Date(e.body.eventTime), new Date(arr[i + 1]?.body?.eventTime)),style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd",noWrap: false,margin: 0 },
                { text: e.body.parties[0].status?.reason || "", style: i % 2 === 0 ? "paragraphEven" : "paragraphOdd", noWrap: false,margin: 0 }
              ]
            ),
          ]
        }
      }
    ],
    styles: {
      table: {margin: [0,0,0,0]},
      h1: {
        fontSize: 14,
        alignment: 'left',
        bold: true,
        margin: [0, 0, 0, 0]
      },
      h2: {
        fontSize: 12,
        alignment: 'left',
        bold: true,
        margin: [0, 0, 0, 0]
      },
      h3: {
        fontSize: 10,
        alignment: 'left',
        bold: false,
        margin: [0, 0, 0, 0]
      },
      header: {
        fontSize: 12,
        bold: true,
        alignment: 'left',
        margin: [0,20]
      },
      header2: {
        fontSize: 7,
        bold: true
      },
      paragraphOdd: {
        fontSize: 7,
        margin: [0,0,0,0]
      },
      paragraphEven: {
        fontSize: 7,
        margin: [0,0,0,0],
        fillColor: '#edf4ff'
      }
    }
  }
  const createPDF = () => {
    console.log(Array.from(EXEvents.values()).flat())
    pdfMake.createPdf(docDef as any).open()
  }
  return (
    <div className="c2g-timeline-root">
      {isCX ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            minHeight:
              300 +
              CXEvents.size * 30 +
              EXEvents.size * 30 +
              (CXEvents.size * 30 +
                EXEvents.size * 30 + 
                cxTransfersToEx.size * 30 +
                cxTransfersFromEx.size * 30 +
                exTransferToCx.size * 30 +
                exTransferFromCx.size * 30),
            position: "relative",
          }}
          className={`c2g-timeline-container ${
            mode === "light" ? "light" : "dark"
          }`}
        >
          <div className="granularity-box">
            <button
              className="c2g-zoom-button"
              type="button"
              onClick={() =>
                handleGranularity(granularity + 0.5, setGranularity)
              }
            >
              <ZoomIn style={{ fill: handleColorFillTop(mode, granularity) }} />
            </button>
            <button
              className="c2g-zoom-button"
              type="button"
              onClick={() =>
                handleGranularity(granularity - 0.5, setGranularity)
              }
            >
              <ZoomOut
                style={{ fill: handleColorFillBottom(mode, granularity) }}
              />
            </button>
          </div>
          <div className={`left-c2g-box ${mode === "light" ? "light" : "dark"}`} style={{ position: "relative" }}>
            <div className="party-detail" style={{marginTop: 42}}/>
            {cxTransfersFromEx &&
              Array.from(cxTransfersFromEx.values()).map((device, i) => {
                const { ivr } = device[0]?.body?.parties[0];
                const accordionId = device[0].index;
                return (
                  // <Accordion
                  //   style={{
                  //     background: renderAccordionScheme(
                  //       mode,
                  //       expanded === accordionId
                  //     ),
                  //     color: mode === "light" ? "black" : "white",
                  //     borderRadius: 4,
                  //   }}
                  //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                  //   square
                  //   expanded={expanded === accordionId}
                  //   onChange={() =>
                  //     handleChange(accordionId, setExpanded, expanded)
                  //   }
                  //   elevation={0}
                  // >
                  //   <AccordionSummary
                  //     expandIcon={
                  //       <ArrowDropDown
                  //         style={{
                  //           color: mode === "light" ? "black" : "white",
                  //         }}
                  //       />
                  //     }
                  //     style={{
                  //       flexDirection: "row-reverse",
                  //       borderLeft:
                  //         expanded === accordionId ? "5px solid #0684bd" : "",
                  //       background: expanded === accordionId ? "#2196f34d" : "",
                  //     }}
                  //     aria-controls={`${i}-content`}
                  //     id={`${i}-header`}
                  //   >
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       {ivr && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <SettingsVoice style={{ paddingRight: 10 }} />
                  //           IVR - {ivr}
                  //         </span>
                  //       )}
                  //       {device[0]?.body?.parties[0]?.queue && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <PeopleAlt style={{ paddingRight: 10 }} />
                  //           {historicalQueues?.find(
                  //             (queue: any) =>
                  //               queue?.id === device[0]?.body?.parties[0]?.queue
                  //           )
                  //             ? `${
                  //                 historicalQueues.find(
                  //                   (queue: any) =>
                  //                     queue?.id ===
                  //                     device[0]?.body?.parties[0]?.queue
                  //                 )?.name
                  //               }`
                  //             : `Queue - ${device[0]?.body?.parties[0]?.queue}`}
                  //         </span>
                  //       )}
                  //       {device[0]?.body?.parties[0]?.user && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <Person style={{ paddingRight: 10 }} />
                  //           {historicalUsers?.find(
                  //             (user: any) =>
                  //               user?.id === device[0]?.body?.parties[0]?.user
                  //           )
                  //             ? `${
                  //                 historicalUsers.find(
                  //                   (user: any) =>
                  //                     user?.id ===
                  //                     device[0]?.body?.parties[0]?.user
                  //                 ).firstName
                  //               } ${
                  //                 historicalUsers.find(
                  //                   (user: any) =>
                  //                     user?.id ===
                  //                     device[0]?.body?.parties[0]?.user
                  //                 ).lastName
                  //               }`
                  //             : `${device[0]?.body?.parties[0]?.accountId}`}
                  //         </span>
                  //       )}
                  //     </div>
                  //   </AccordionSummary>
                  //   <AccordionDetails>
                  //     <div
                  //       style={{
                  //         width: "100%",
                  //         paddingLeft: 30,
                  //         background: mode === "light" ? "white" : "#181d1f",
                  //       }}
                  //     >
                  //       {device?.map((leg) => {
                  //         const { status, direction, from, to } =
                  //           leg?.body?.parties[0];
                  //         const { eventTime } = leg.body;
                  //         return (
                  //           <Accordion
                  //             square
                  //             elevation={0}
                  //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                  //             style={{
                  //               background:
                  //                 mode === "light" ? "white" : "#181d1f",
                  //               color: mode === "light" ? "black" : "white",
                  //             }}
                  //           >
                  //             <AccordionSummary
                  //               style={{
                  //                 flexDirection: "row-reverse",
                  //                 background: "#11111105",
                  //               }}
                  //               expandIcon={
                  //                 <ArrowDropDown
                  //                   style={{
                  //                     color:
                  //                       mode === "light" ? "black" : "white",
                  //                   }}
                  //                 />
                  //               }
                  //             >
                  //               event {status.code || leg.body?.sequence}
                  //             </AccordionSummary>
                  //             <AccordionDetails>
                  //               <div style={{ width: "100%", marginLeft: 20 }}>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Time: </p>
                  //                   <p>
                  //                     {new Date(eventTime).toLocaleTimeString(
                  //                       "en-US",
                  //                       {
                  //                         hour: "numeric",
                  //                         minute: "numeric",
                  //                         second: "numeric",
                  //                         hour12: true,
                  //                       }
                  //                     )}
                  //                   </p>
                  //                 </div>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Direction: </p>
                  //                   <p>{direction}</p>
                  //                 </div>
                  //                 <div className="c2g-rows-box">
                  //                   <p>status: </p>
                  //                   <p>
                  //                     {status.code &&
                  //                     status.code === "Proceeding"
                  //                       ? "Ringing"
                  //                       : status.code}
                  //                   </p>
                  //                 </div>
                  //                 {status.reason && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>reason: </p>
                  //                     <p>{status.reason}</p>
                  //                   </div>
                  //                 )}
                  //                 {from && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>From: </p>
                  //                     <div style={{ textAlign: "end" }}>
                  //                       <p>{from.phoneNumber}</p>
                  //                       <p>{from.name}</p>
                  //                       <p>{from.extensionId}</p>
                  //                       <p>{from.extensionNumber}</p>
                  //                     </div>
                  //                   </div>
                  //                 )}
                  //                 {to && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>To: </p>
                  //                     <div style={{ textAlign: "end" }}>
                  //                       <p>{to.phoneNumber}</p>
                  //                       <p>{to.name}</p>
                  //                       <p>{to.extensionId}</p>
                  //                       <p>{to.extensionNumber}</p>
                  //                     </div>
                  //                   </div>
                  //                 )}
                  //               </div>
                  //             </AccordionDetails>
                  //           </Accordion>
                  //         );
                  //       })}
                  //     </div>
                  //   </AccordionDetails>
                  // </Accordion>
                  
                  <div style={{
                    background: renderAccordionScheme(
                      mode,
                     expanded === accordionId
                   ),
                   height: 35,
                   display: 'flex',
                  alignItems: "center",
                   color: mode === "light" ? "black" : "white",
                    borderRadius: 4,
                     }}
                     className={`c2g-device-accordion c2g-outer-accordion c2g-accordion ex-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                  {ivr && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <SettingsVoice style={{ paddingRight: 10 }} />
                      IVR - {ivr}
                    </span>
                  )}
                  {device[0]?.body?.parties[0]?.queue && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <PeopleAlt style={{ paddingRight: 10 }} />
                      {historicalQueues?.find(
                        (queue: any) =>
                          queue?.id === device[0]?.body?.parties[0]?.queue
                      )
                        ? `${
                            historicalQueues.find(
                              (queue: any) =>
                                queue?.id ===
                                device[0]?.body?.parties[0]?.queue
                            )?.name
                          }`
                        : `Queue - ${device[0]?.body?.parties[0]?.queue}`}
                    </span>
                  )}
                  {device[0]?.body?.parties[0]?.user && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <Person style={{ paddingRight: 10 }} />
                      {historicalUsers?.find(
                        (user: any) =>
                          user?.id === device[0]?.body?.parties[0]?.user
                      )
                        ? `${
                            historicalUsers.find(
                              (user: any) =>
                                user?.id ===
                                device[0]?.body?.parties[0]?.user
                            ).firstName
                          } ${
                            historicalUsers.find(
                              (user: any) =>
                                user?.id ===
                                device[0]?.body?.parties[0]?.user
                            ).lastName
                          }`
                        : `${device[0]?.body?.parties[0]?.accountId}`}
                    </span>
                  )}
                </div>
                </div>
                );
              })}
            {cxTransfersFromEx && cxTransfersFromEx.size > 0 && (
              <div className={`transfer-indicator-box ${mode}`}>
                <PhoneForwarded
                  style={{ color: mode === "light" ? "black" : "white" }}
                />
                <PhoneForwarded
                  style={{ color: mode === "light" ? "black" : "white" }}
                />
                <PhoneForwarded
                  style={{ color: mode === "light" ? "black" : "white" }}
                />
                <b className="transfer-text-box">Transfer to CX</b>
              </div>
            )}
            {Array.from(CXEvents.values()).map((event, i) => {
              const { type } = event[0];
              const accordionId = `${i}-${event[0]?.timeStamp}`;

              return (
                // <Accordion
                //   style={{
                //     background: renderAccordionScheme(
                //       mode,
                //       expanded === accordionId
                //     ),
                //     color: mode === "light" ? "black" : "white",
                //     borderRadius: 4,
                //   }}
                //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                //   square
                //   expanded={expanded === accordionId}
                //   onChange={() =>
                //     handleChange(accordionId, setExpanded, expanded)
                //   }
                //   elevation={0}
                // >
                //   <AccordionSummary
                //     expandIcon={
                //       <ArrowDropDown
                //         style={{
                //           color: mode === "light" ? "black" : "white",
                //         }}
                //       />
                //     }
                //     style={{
                //       flexDirection: "row-reverse",
                //       borderLeft:
                //         expanded === accordionId ? "5px solid #0684bd" : "",
                //       background: expanded === accordionId ? "#2196f34d" : "",
                //     }}
                //     aria-controls={`${i}-content`}
                //     id={`${i}-header`}
                //   >
                //     <div style={{ display: "flex", alignItems: "center" }}>
                //       {type === "queue" && (
                //         <span style={{ display: "flex", alignItems: "center" }}>
                //           <PeopleAlt style={{ paddingRight: 10 }} />
                //           {event[0]?.queueName || "QUEUE"}
                //         </span>
                //       )}
                //       {type === "agent" && (
                //         <span style={{ display: "flex", alignItems: "center" }}>
                //           <Person style={{ paddingRight: 10 }} />
                //           {event[0]?.username || "AGENT"}
                //         </span>
                //       )}
                //     </div>
                //   </AccordionSummary>
                //   <AccordionDetails>
                //     <div
                //       style={{
                //         width: "100%",
                //         paddingLeft: 30,
                //         background: mode === "light" ? "white" : "#181d1f",
                //       }}
                //     >
                //       {event?.map((leg) => {
                //         return (
                //           <Accordion
                //             square
                //             elevation={0}
                //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                //             style={{
                //               background:
                //                 mode === "light" ? "white" : "#181d1f",
                //               color: mode === "light" ? "black" : "white",
                //             }}
                //           >
                //             <AccordionSummary
                //               style={{
                //                 flexDirection: "row-reverse",
                //                 background: "#00000000",
                //               }}
                //               expandIcon={
                //                 <ArrowDropDown
                //                   style={{
                //                     color: mode === "light" ? "black" : "white",
                //                   }}
                //                 />
                //               }
                //             >
                //               event {reasonRenderer(leg.event)}
                //             </AccordionSummary>
                //             <AccordionDetails>
                //               <div style={{ width: "100%", marginLeft: 20 }}>
                //                 <div className="c2g-rows-box">
                //                   <p>Time: </p>
                //                   <p>
                //                     {new Date(
                //                       new Date(leg.timeStamp).getTime() +
                //                         4 * 60 * 60 * 1000
                //                     ).toLocaleTimeString("en-US", {
                //                       hour: "numeric",
                //                       minute: "numeric",
                //                       second: "numeric",
                //                       hour12: true,
                //                     })}
                //                   </p>
                //                 </div>
                //               </div>
                //             </AccordionDetails>
                //           </Accordion>
                //         );
                //       })}
                //     </div>
                //   </AccordionDetails> 
                // </Accordion>
                <div style={{
                    background: renderCXAccordionScheme(
                      mode,
                     expanded === accordionId
                   ),
                   height: 35,
                   display: 'flex',
                  alignItems: "center",
                   color: mode === "light" ? "black" : "white",
                    borderRadius: 4,
                     }}
                    className={`c2g-device-accordion c2g-outer-accordion c2g-accordion cx-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                      {type === "queue" && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <PeopleAlt style={{ paddingRight: 10 }} />
                          {event[0]?.queueName || "QUEUE"}
                        </span>
                      )}
                      {type === "agent" && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <Person style={{ paddingRight: 10 }} />
                          {event[0]?.username || "AGENT"}
                        </span>
                      )}
                    </div>
                </div>
              );
            })}
            {cxTransfersToEx &&
              Array.from(cxTransfersToEx.values()).map((device, i) => {
                const { ivr } = device[0]?.body?.parties[0];
                const accordionId = device[0].index;

                return (
                  // <Accordion
                  //   style={{
                  //     background: renderAccordionScheme(
                  //       mode,
                  //       expanded === accordionId
                  //     ),
                  //     color: mode === "light" ? "black" : "white",
                  //     borderRadius: 4,
                  //   }}
                  //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                  //   square
                  //   expanded={expanded === accordionId}
                  //   onChange={() =>
                  //     handleChange(accordionId, setExpanded, expanded)
                  //   }
                  //   elevation={0}
                  // >
                  //   <AccordionSummary
                  //     expandIcon={
                  //       <ArrowDropDown
                  //         style={{
                  //           color: mode === "light" ? "black" : "white",
                  //         }}
                  //       />
                  //     }
                  //     style={{
                  //       flexDirection: "row-reverse",
                  //       borderLeft:
                  //         expanded === accordionId ? "5px solid #0684bd" : "",
                  //       background: expanded === accordionId ? "#2196f34d" : "",
                  //     }}
                  //     aria-controls={`${i}-content`}
                  //     id={`${i}-header`}
                  //   >
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       {ivr && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <SettingsVoice style={{ paddingRight: 10 }} />
                  //           IVR - {ivr}
                  //         </span>
                  //       )}
                  //       {device[0]?.body?.parties[0]?.queue && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <PeopleAlt style={{ paddingRight: 10 }} />
                  //           {historicalQueues?.find(
                  //             (queue: any) =>
                  //               queue?.id === device[0]?.body?.parties[0]?.queue
                  //           )
                  //             ? `${
                  //                 historicalQueues.find(
                  //                   (queue: any) =>
                  //                     queue?.id ===
                  //                     device[0]?.body?.parties[0]?.queue
                  //                 )?.name
                  //               }`
                  //             : `Queue - ${device[0]?.body?.parties[0]?.queue}`}
                  //         </span>
                  //       )}
                  //       {device[0]?.body?.parties[0]?.user && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <Person style={{ paddingRight: 10 }} />
                  //           {historicalUsers?.find(
                  //             (user: any) =>
                  //               user?.id === device[0]?.body?.parties[0]?.user
                  //           )
                  //             ? `${
                  //                 historicalUsers.find(
                  //                   (user: any) =>
                  //                     user?.id ===
                  //                     device[0]?.body?.parties[0]?.user
                  //                 ).firstName
                  //               } ${
                  //                 historicalUsers.find(
                  //                   (user: any) =>
                  //                     user?.id ===
                  //                     device[0]?.body?.parties[0]?.user
                  //                 ).lastName
                  //               }`
                  //             : `${device[0]?.body?.parties[0]?.accountId}`}
                  //         </span>
                  //       )}
                  //     </div>
                  //   </AccordionSummary>
                  //   <AccordionDetails>
                  //     <div
                  //       style={{
                  //         width: "100%",
                  //         paddingLeft: 30,
                  //         background: mode === "light" ? "white" : "#181d1f",
                  //       }}
                  //     >
                  //       {device?.map((leg) => {
                  //         const { status, direction, from, to } =
                  //           leg?.body?.parties[0];
                  //         const { eventTime } = leg.body;
                  //         return (
                  //           <Accordion
                  //             square
                  //             elevation={0}
                  //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                  //             style={{
                  //               background:
                  //                 mode === "light" ? "white" : "#181d1f",
                  //               color: mode === "light" ? "black" : "white",
                  //             }}
                  //           >
                  //             <AccordionSummary
                  //               style={{
                  //                 flexDirection: "row-reverse",
                  //                 background: "#00000000",
                  //               }}
                  //               expandIcon={
                  //                 <ArrowDropDown
                  //                   style={{
                  //                     color:
                  //                       mode === "light" ? "black" : "white",
                  //                   }}
                  //                 />
                  //               }
                  //             >
                  //               event {status.code || leg.body?.sequence}
                  //             </AccordionSummary>
                  //             <AccordionDetails>
                  //               <div style={{ width: "100%", marginLeft: 20 }}>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Time: </p>
                  //                   <p>
                  //                     {new Date(eventTime).toLocaleTimeString(
                  //                       "en-US",
                  //                       {
                  //                         hour: "numeric",
                  //                         minute: "numeric",
                  //                         second: "numeric",
                  //                         hour12: true,
                  //                       }
                  //                     )}
                  //                   </p>
                  //                 </div>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Direction: </p>
                  //                   <p>{direction}</p>
                  //                 </div>
                  //                 <div className="c2g-rows-box">
                  //                   <p>status: </p>
                  //                   <p>
                  //                     {status.code &&
                  //                     status.code === "Proceeding"
                  //                       ? "Ringing"
                  //                       : status.code}
                  //                   </p>
                  //                 </div>
                  //                 {status.reason && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>reason: </p>
                  //                     <p>{status.reason}</p>
                  //                   </div>
                  //                 )}
                  //                 {from && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>From: </p>
                  //                     <div style={{ textAlign: "end" }}>
                  //                       <p>{from.phoneNumber}</p>
                  //                       <p>{from.name}</p>
                  //                       <p>{from.extensionId}</p>
                  //                       <p>{from.extensionNumber}</p>
                  //                     </div>
                  //                   </div>
                  //                 )}
                  //                 {to && (
                  //                   <div className="c2g-rows-box">
                  //                     <p>To: </p>
                  //                     <div style={{ textAlign: "end" }}>
                  //                       <p>{to.phoneNumber}</p>
                  //                       <p>{to.name}</p>
                  //                       <p>{to.extensionId}</p>
                  //                       <p>{to.extensionNumber}</p>
                  //                     </div>
                  //                   </div>
                  //                 )}
                  //               </div>
                  //             </AccordionDetails>
                  //           </Accordion>
                  //         );
                  //       })}
                  //     </div>
                  //   </AccordionDetails>
                  // </Accordion>
                  <div style={{
                    background: renderAccordionScheme(
                      mode,
                     expanded === accordionId
                   ),
                   height: 35,
                   display: 'flex',
                  alignItems: "center",
                   color: mode === "light" ? "black" : "white",
                    borderRadius: 4,
                     }}
                     className={`c2g-device-accordion c2g-outer-accordion c2g-accordion ex-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                  {ivr && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <SettingsVoice style={{ paddingRight: 10 }} />
                      IVR - {ivr}
                    </span>
                  )}
                  {device[0]?.body?.parties[0]?.queue && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <PeopleAlt style={{ paddingRight: 10 }} />
                      {historicalQueues?.find(
                        (queue: any) =>
                          queue?.id === device[0]?.body?.parties[0]?.queue
                      )
                        ? `${
                            historicalQueues.find(
                              (queue: any) =>
                                queue?.id ===
                                device[0]?.body?.parties[0]?.queue
                            )?.name
                          }`
                        : `Queue - ${device[0]?.body?.parties[0]?.queue}`}
                    </span>
                  )}
                  {device[0]?.body?.parties[0]?.user && (
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <Person style={{ paddingRight: 10 }} />
                      {historicalUsers?.find(
                        (user: any) =>
                          user?.id === device[0]?.body?.parties[0]?.user
                      )
                        ? `${
                            historicalUsers.find(
                              (user: any) =>
                                user?.id ===
                                device[0]?.body?.parties[0]?.user
                            ).firstName
                          } ${
                            historicalUsers.find(
                              (user: any) =>
                                user?.id ===
                                device[0]?.body?.parties[0]?.user
                            ).lastName
                          }`
                        : `${device[0]?.body?.parties[0]?.accountId}`}
                    </span>
                  )}
                </div>
                </div>
                );
              })}
          </div>
          <div
            className="right-c2g-timeline"
            style={{ width: "100%", overflow: "scroll", position: "relative" }}
          >
            <div
              style={{ position: "absolute", top: 60 }}
              onMouseMove={(e) => handleMouseMove(e, setMouseXCoord)}
            >
              {cxTransfersFromEx &&
                Array.from(cxTransfersFromEx.values()).map(
                  (device: CallEvent[], j: number) => (
                    <div
                      className="device-box"
                      style={{ position: "relative" }}
                    >
                      {device.map((leg: CallEvent, i: number) => (
                       <>
                      
                       <span
                          onMouseEnter={() => setExpanded(`${device[0]?.index}`)}
                          onMouseLeave={() => setExpanded(false)}
                          className="leg-box ex-leg-box"
                          style={{
                            position: "absolute",
                            transitionDuration: "0.2s",
                            marginLeft:
                              device[i] === device[0]
                                ? `calc(${
                                    calculateWidths(
                                      device.map((d) => d.body.eventTime),
                                      device.length,
                                      timeStamps,
                                      granularity
                                    )[i]
                                  })`
                                : -0,
                            left: `calc(${
                              calculateWidths(
                                device.map((d) => d.body.eventTime),
                                device.length,
                                timeStamps,
                                granularity
                              )[i]
                            }px)`,
                            width: device[i + 1]
                              ? `calc(${
                                  calculateWidths(
                                    device.map((d) => d.body.eventTime),
                                    device.length,
                                    timeStamps,
                                    granularity
                                  )[i + 1] -
                                  calculateWidths(
                                    device.map((d) => d.body.eventTime),
                                    device.length,
                                    timeStamps,
                                    granularity
                                  )[i]
                                }px + 20px)`
                              : 20,
                            background: `${renderBgStyles(leg)}`,
                            // height: "2px",
                            // top: "50%",
                            // transform: "translateY(-50%)",
                          }}
                        >
                          <RenderEXLeg
                            hasCX={!!cxAgents}
                            device={device}
                            event={leg}
                            index={i + 1}
                            sequence={sequence}
                            user={historicalUsers.find(
                              (user: any) =>
                                user.id === leg.body.parties[0]?.extensionId
                            )}
                            queue={historicalQueues.find(
                              (queue: any) =>
                                queue.id === leg.body.parties[0]?.queue
                            )}
                            mode={mode}
                            deviceId={device[0].index!}
                            setExpanded={setExpanded}
                          />
                        </span>
                       </>
                      ))}
                    </div>
                  )
                )}
              {Array.from(CXEvents.values()).map(
                (device: CxCallEvent[], j: number,) => (
                  <div className="device-box" style={{ position: "relative" }}>
                    {device
                      .sort((a: CxCallEvent, b: CxCallEvent) => {
                        if (a.event === "abandonTime") {
                          return -1;
                        }
                        if (a.event === "disconnectedTime") {
                          return 1;
                        }
                        return 0;
                      })
                      .map((event: any, i: number, array: CxCallEvent[]) => {
                        const nextItem = array[i + 1];
                        const adjustEventDate = (date: string) => {
                          const dateVal = new Date(date as string);
                          const timeZoneOffset =
                            dateVal.getTimezoneOffset() * 60 * 1000;
                          return dateVal.getTime() + timeZoneOffset;
                        };
                        return (
                          <>
                         
                          <span 
                          onMouseEnter={() => setExpanded(`${j}-${device[0]?.timeStamp}`)}
                          onMouseLeave={() => setExpanded(false)}
                            className="leg-box cx-leg-box"
                            style={{
                              position: "absolute",
                              transitionDuration: "0.2s",
                              marginLeft: 0,
                              width: nextItem
                                ? ((Math.floor(
                                    adjustEventDate(
                                      nextItem?.timeStamp as string
                                    )
                                  ) -
                                    Math.floor(
                                      adjustEventDate(event.timeStamp)
                                    )) /
                                    100) *
                                    granularity +
                                  20
                                : 20,
                              left:
                                (Math.floor(
                                  adjustEventDate(event?.timeStamp) -
                                    timeStamps[0]
                                ) *
                                  granularity) /
                                100,
                              background: renderCXBgStyles(event),
                              // height: "2px",
                              // top: "50%",
                              // transform: "translateY(-50%)",
                            }}
                          >
                            <RenderCxLeg
                              index={i}
                              event={event}
                              eventArr={array}
                              cxAgents={cxAgents}
                              mode={mode}
                              setExpanded={setExpanded}
                              deviceId={`${j}-${device[0]?.timeStamp}`}
                            />
                          </span>
                          </>
                        );
                      })}
                  </div>
                )
              )}
              {cxTransfersToEx &&
                Array.from(cxTransfersToEx.values()).map(
                  (device: CallEvent[], j: number) => (
                    <div
                      className="device-box"
                      style={{ position: "relative" }}
                    >
                      {device.map((leg: CallEvent, i: number) => (
                        <span
                          onMouseEnter={() => setExpanded(`${device[0]?.index}`)}
                          onMouseLeave={() => setExpanded(false)}
                          className="leg-box ex-leg-box"
                          style={{
                            position: "absolute",
                            transitionDuration: "0.2s",
                            marginLeft:
                              device[i] === device[0]
                                ? `calc(${
                                    calculateWidths(
                                      device.map((d) => d.body.eventTime),
                                      device.length,
                                      timeStamps,
                                      granularity
                                    )[i]
                                  })`
                                : -0,
                            left: `calc(${
                              calculateWidths(
                                device.map((d) => d.body.eventTime),
                                device.length,
                                timeStamps,
                                granularity
                              )[i]
                            }px)`,
                            width: device[i + 1]
                              ? `calc(${
                                  calculateWidths(
                                    device.map((d) => d.body.eventTime),
                                    device.length,
                                    timeStamps,
                                    granularity
                                  )[i + 1] -
                                  calculateWidths(
                                    device.map((d) => d.body.eventTime),
                                    device.length,
                                    timeStamps,
                                    granularity
                                  )[i]
                                }px + 20px)`
                              : 20,
                            background: `${renderBgStyles(leg)}`,
                          }}
                        >
                          <RenderEXLeg
                          hasCX={!!cxAgents}
                            device={device}
                            event={leg}
                            index={i + 1}
                            sequence={sequence}
                            user={historicalUsers.find(
                              (user: any) =>
                                user.id === leg.body.parties[0]?.extensionId
                            )}
                            queue={historicalQueues.find(
                              (queue: any) =>
                                queue.id === leg.body.parties[0]?.queue
                            )}
                            mode={mode}
                            deviceId={device[0].index!}
                            setExpanded={setExpanded}
                          />
                        </span>
                      ))}
                    </div>
                  )
                )}
            </div>
            <div
              onMouseLeave={handleMouseLeave}
              onMouseMove={(e) => handleMouseMove(e, setMouseXCoord)}
              className={`background-grid ${
                mode === "light" ? "light-grid" : "dark-grid"
              } ${mouseCoords ? "in-focus" : ""}`}
              style={{
                height: "100%",
                position: "relative",
                width: 
                  ((timeStamps[1] - timeStamps[0]) / 100 + 50) * granularity + 100,
                minWidth: "100%",
              }}
            >
              <div style={{
                position: 'absolute',
                width:((timeStamps[1] - timeStamps[0]) / 100 + 50) * granularity + 100,
                minWidth: "100%", 
                top: 0,
                height: '100%'
                }} 
                className={`top-grid ${mode === "light" ? "top-light-grid" : "top-dark-grid"}`}/>
              <MouseIndicator />
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  height: 40,
                  marginTop: -20,
                  overflow: "visible",
                  // borderBottom: mode === 'light' ? "1px solid #555" : "1px solid #999"
                }}
              >
                <div style={{width: '100%',zIndex: 2,  background: mode === 'light' ? "#eee" :'#191919' , borderBottom: '2px solid #444', height: 40}}>
                <HandlePlatformTransferLabels
                  timeStamps={timeStamps}
                  EXEvents={EXEvents}
                  CXEvents={CXEvents}
                  cxTransfersFromEx={cxTransfersFromEx}
                  cxTransfersToEx={cxTransfersToEx}
                  exTransferFromCx={exTransferFromCx}
                  exTransferToCx={exTransferToCx}
                  granularity={granularity}
                  mode={mode}
                />
                </div>
                {getTimeIncrements(
                  timeStamps[0],
                  timeStamps[1] + 300000,
                  mode,
                  granularity,
                  !!mouseCoords
                )}
                {mouseCoords &&
                  renderTimeOnHover(mouseCoords, granularity, mode)}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            minHeight:
            300 +
            CXEvents.size * 30 +
            EXEvents.size * 30 +
            (CXEvents.size * 30 +
              EXEvents.size * 30 + 
              cxTransfersToEx.size * 30 +
              cxTransfersFromEx.size * 30 +
              exTransferToCx.size * 30 +
              exTransferFromCx.size * 30),
            position: "relative",
          }}
          className={`c2g-timeline-container ${
            mode === "light" ? "light" : "dark"
          }`}
        >
          <div className="granularity-box">
            <button
              className="c2g-zoom-button"
              type="button"
              onClick={() => handleGranularity(granularity + 1, setGranularity)}
            >
              <ZoomIn style={{ fill: handleColorFillTop(mode, granularity) }} />
            </button>
            <button
              className="c2g-zoom-button"
              type="button"
              onClick={() => handleGranularity(granularity - 1, setGranularity)}
            >
              <ZoomOut
                style={{ fill: handleColorFillBottom(mode, granularity) }}
              />
            </button>
          </div>

          <div
            className={`left-c2g-box ${mode === "light" ? "light" : "dark"}`}
            style={{ position: "relative" }}
          >
            {/* {orgId ===  "3154756020" && (
              <div className="party-detail" style={{marginTop: 0}}>
            <button type='button' onClick={createPDF} aria-label="download PDF" style={{border: '1px solid #888', borderRadius: 5, marginTop: 10, padding:'0px 5px',background: "#00000000", cursor: 'pointer', display: 'flex', alignItems: 'end'}}><GetApp fontSize="small" style={{color: mode === 'light' ? "black" : "white", paddingTop: 0}} /> <b style={{fontSize: '1.2em',color: mode === 'light' ? "black" : "white"}}>PDF</b></button>
            </div>
            )} */}
            <div className="party-detail" style={{marginTop: 42}}/>
            
            {exTransferFromCx &&
              Array.from(exTransferFromCx.values()).map((event, i) => {
                const { type } = event[0];
                const accordionId = `${i}-${event[0]?.timeStamp}`;
                return (
                  // <Accordion
                  //   style={{
                  //     background: renderAccordionScheme(
                  //       mode,
                  //       expanded === accordionId
                  //     ),
                  //     color: mode === "light" ? "black" : "white",
                  //     borderRadius: 4,
                  //   }}
                  //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                  //   square
                  //   expanded={expanded === accordionId}
                  //   onChange={() =>
                  //     handleChange(accordionId, setExpanded, expanded)
                  //   }
                  //   elevation={0}
                  // >
                  //   <AccordionSummary
                  //     expandIcon={
                  //       <ArrowDropDown
                  //         style={{
                  //           color: mode === "light" ? "black" : "white",
                  //         }}
                  //       />
                  //     }
                  //     style={{
                  //       flexDirection: "row-reverse",
                  //       borderLeft:
                  //         expanded === accordionId ? "5px solid #0684bd" : "",
                  //       background: expanded === accordionId ? "#2196f34d" : "",
                  //     }}
                  //     aria-controls={`${i}-content`}
                  //     id={`${i}-header`}
                  //   >
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       {type === "queue" && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <PeopleAlt style={{ paddingRight: 10 }} />
                  //           {event[0]?.queueName || "QUEUE"}
                  //         </span>
                  //       )}
                  //       {type === "agent" && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <Person style={{ paddingRight: 10 }} />
                  //           {event[0]?.username || "AGENT"}
                  //         </span>
                  //       )}
                  //     </div>
                  //   </AccordionSummary>
                  //   <AccordionDetails>
                  //     <div
                  //       style={{
                  //         width: "100%",
                  //         paddingLeft: 30,
                  //         background: mode === "light" ? "white" : "#181d1f",
                  //       }}
                  //     >
                  //       {event?.map((leg) => {
                  //         return (
                  //           <Accordion
                  //             square
                  //             elevation={0}
                  //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                  //             style={{
                  //               background:
                  //                 mode === "light" ? "white" : "#181d1f",
                  //               color: mode === "light" ? "black" : "white",
                  //             }}
                  //           >
                  //             <AccordionSummary
                  //               style={{
                  //                 flexDirection: "row-reverse",
                  //                 background: "#00000000",
                  //               }}
                  //               expandIcon={
                  //                 <ArrowDropDown
                  //                   style={{
                  //                     color:
                  //                       mode === "light" ? "black" : "white",
                  //                   }}
                  //                 />
                  //               }
                  //             >
                  //               event {reasonRenderer(leg.event)}
                  //             </AccordionSummary>
                  //             <AccordionDetails>
                  //               <div style={{ width: "100%", marginLeft: 20 }}>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Time: </p>
                  //                   <p>
                  //                     {new Date(
                  //                       new Date(leg.timeStamp).getTime() +
                  //                         4 * 60 * 60 * 1000
                  //                     ).toLocaleTimeString("en-US", {
                  //                       hour: "numeric",
                  //                       minute: "numeric",
                  //                       second: "numeric",
                  //                       hour12: true,
                  //                     })}
                  //                   </p>
                  //                 </div>
                  //               </div>
                  //             </AccordionDetails>
                  //           </Accordion>
                  //         );
                  //       })}
                  //     </div>
                  //   </AccordionDetails>
                  // </Accordion>
                  <div style={{
                    background: renderCXAccordionScheme(
                      mode,
                     expanded === accordionId
                   ),
                   height: 35,
                   display: 'flex',
                  alignItems: "center",
                   color: mode === "light" ? "black" : "white",
                    borderRadius: 4,
                     }}
                     className={`c2g-device-accordion c2g-outer-accordion c2g-accordion cx-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                      {type === "queue" && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <PeopleAlt style={{ paddingRight: 10 }} />
                          {event[0]?.queueName || "QUEUE"}
                        </span>
                      )}
                      {type === "agent" && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <Person style={{ paddingRight: 10 }} />
                          {event[0]?.username || "AGENT"}
                        </span>
                      )}
                    </div>
                </div>
                );
              })}
            {/* {exTransferFromCx && exTransferFromCx.size > 0 && (
              <div className={`transfer-indicator-box ${mode}`}>
                <PhoneForwarded
                  fontSize="small"
                  style={{ color: mode === "light" ? "black" : "white" }}
                />
                <b className="transfer-text-box">Transfer to EX</b>
              </div>
            )} */}
            {Array.from(EXEvents.values()).map((device, i) => {
              const { ivr } = device[0]?.body?.parties[0];
              const accordionId = device[0].index;

              return (
                // <Accordion
                //   style={{
                //     background: renderAccordionScheme(
                //       mode,
                //       expanded === accordionId
                //     ),
                //     color: mode === "light" ? "black" : "white",
                //     borderRadius: 4,
                //   }}
                //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                //   square
                //   expanded={expanded === accordionId}
                //   onChange={() =>
                //     handleChange(accordionId, setExpanded, expanded)
                //   }
                //   elevation={0}
                // >
                //   <AccordionSummary
                //     expandIcon={
                //       <ArrowDropDown
                //         style={{
                //           color: mode === "light" ? "black" : "white",
                //         }}
                //       />
                //     }
                //     style={{
                //       flexDirection: "row-reverse",
                //       borderLeft:
                //         expanded === accordionId ? "5px solid #0684bd" : "",
                //       background: expanded === accordionId ? "#2196f34d" : "",
                //     }}
                //     aria-controls={`${i}-content`}
                //     id={`${i}-header`}
                //   >
                   
                //   </AccordionSummary>
                //   <AccordionDetails>
                //     <div
                //       style={{
                //         width: "100%",
                //         paddingLeft: 30,
                //         background: mode === "light" ? "white" : "#181d1f",
                //       }}
                //     >
                //       {device?.map((leg) => {
                //         const { status, direction, from, to } =
                //           leg?.body?.parties[0];
                //         const { eventTime } = leg.body;
                //         return (
                //           <Accordion
                //             square
                //             elevation={0}
                //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                //             style={{
                //               background:
                //                 mode === "light" ? "white" : "#181d1f",
                //               color: mode === "light" ? "black" : "white",
                //             }}
                //           >
                //             <AccordionSummary
                //               style={{
                //                 flexDirection: "row-reverse",
                //                 background: "#00000000",
                //               }}
                //               expandIcon={
                //                 <ArrowDropDown
                //                   style={{
                //                     color: mode === "light" ? "black" : "white",
                //                   }}
                //                 />
                //               }
                //             >
                //               event {status.code || leg.body?.sequence}
                //             </AccordionSummary>
                //             <AccordionDetails>
                //               <div style={{ width: "100%", marginLeft: 20 }}>
                //                 <div className="c2g-rows-box">
                //                   <p>Time: </p>
                //                   <p>
                //                     {new Date(eventTime).toLocaleTimeString(
                //                       "en-US",
                //                       {
                //                         hour: "numeric",
                //                         minute: "numeric",
                //                         second: "numeric",
                //                         hour12: true,
                //                       }
                //                     )}
                //                   </p>
                //                 </div>
                //                 <div className="c2g-rows-box">
                //                   <p>Direction: </p>
                //                   <p>{direction}</p>
                //                 </div>
                //                 <div className="c2g-rows-box">
                //                   <p>status: </p>
                //                   <p>
                //                     {status.code && status.code === "Proceeding"
                //                       ? "Ringing"
                //                       : status.code}
                //                   </p>
                //                 </div>
                //                 {status.reason && (
                //                   <div className="c2g-rows-box">
                //                     <p>reason: </p>
                //                     <p>{status.reason}</p>
                //                   </div>
                //                 )}
                //                 {from && (
                //                   <div className="c2g-rows-box">
                //                     <p>From: </p>
                //                     <div style={{ textAlign: "end" }}>
                //                       <p>{from.phoneNumber}</p>
                //                       <p>{from.name}</p>
                //                       <p>{from.extensionId}</p>
                //                       <p>{from.extensionNumber}</p>
                //                     </div>
                //                   </div>
                //                 )}
                //                 {to && (
                //                   <div className="c2g-rows-box">
                //                     <p>To: </p>
                //                     <div style={{ textAlign: "end" }}>
                //                       <p>{to.phoneNumber}</p>
                //                       <p>{to.name}</p>
                //                       <p>{to.extensionId}</p>
                //                       <p>{to.extensionNumber}</p>
                //                     </div>
                //                   </div>
                //                 )}
                //               </div>
                //             </AccordionDetails>
                //           </Accordion>
                //         );
                //       })}
                //     </div>
                //   </AccordionDetails>
                // </Accordion>
                <div style={{
                  background: renderAccordionScheme(
                    mode,
                   expanded === accordionId
                 ),
                 height: 35,
                 display: 'flex',
                alignItems: "center",
                 color: mode === "light" ? "black" : "white",
                  borderRadius: 4,
                   }}
                   className={`c2g-device-accordion c2g-outer-accordion c2g-accordion ex-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                <div style={{ display: "flex", alignItems: "center" }}>
                {ivr && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <SettingsVoice style={{ paddingRight: 10 }} />
                    IVR - {ivr}
                  </span>
                )}
                {device[0]?.body?.parties[0]?.queue && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <PeopleAlt style={{ paddingRight: 10 }} />
                    {historicalQueues?.find(
                      (queue: any) =>
                        queue?.id === device[0]?.body?.parties[0]?.queue
                    )
                      ? `${
                          historicalQueues.find(
                            (queue: any) =>
                              queue?.id ===
                              device[0]?.body?.parties[0]?.queue
                          )?.name
                        }`
                      : `Queue - ${device[0]?.body?.parties[0]?.queue}`}
                  </span>
                )}
                {device[0]?.body?.parties[0]?.user && (
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <Person style={{ paddingRight: 10 }} />
                    {historicalUsers?.find(
                      (user: any) =>
                        user?.id === device[0]?.body?.parties[0]?.user
                    )
                      ? `${
                          historicalUsers.find(
                            (user: any) =>
                              user?.id ===
                              device[0]?.body?.parties[0]?.user
                          ).firstName
                        } ${
                          historicalUsers.find(
                            (user: any) =>
                              user?.id ===
                              device[0]?.body?.parties[0]?.user
                          ).lastName
                        }`
                      : `${device[0]?.body?.parties[0]?.accountId}`}
                  </span>
                )}
              </div>
              </div>
              );
            })}
            {/* {exTransferToCx && exTransferToCx.size > 0 && (
              <div className={`transfer-indicator-box ${mode}`}>
                <PhoneForwarded
                  fontSize="small"
                  style={{ color: mode === "light" ? "black" : "white" }}
                />
                <b className="transfer-text-box">Transfer to CX </b>
              </div>
            )} */}
            {exTransferToCx && Array.from(exTransferToCx.values()).map((event, i) => {
                const { type } = event[0];
                const accordionId = `${i}-${event[0]?.timeStamp}`;
                return (
                  // <Accordion
                  //   style={{
                  //     background: renderAccordionScheme(
                  //       mode,
                  //       expanded === accordionId
                  //     ),
                  //     color: mode === "light" ? "black" : "white",
                  //     borderRadius: 4,
                  //   }}
                  //   className="c2g-device-accordion c2g-outer-accordion c2g-accordion"
                  //   square
                  //   expanded={expanded === accordionId}
                  //   onChange={() =>
                  //     handleChange(accordionId, setExpanded, expanded)
                  //   }
                  //   elevation={0}
                  // >
                  //   <AccordionSummary
                  //     expandIcon={
                  //       <ArrowDropDown
                  //         style={{
                  //           color: mode === "light" ? "black" : "white",
                  //         }}
                  //       />
                  //     }
                  //     style={{
                  //       flexDirection: "row-reverse",
                  //       borderLeft:
                  //         expanded === accordionId ? "5px solid #0684bd" : "",
                  //       background: expanded === accordionId ? "#2196f34d" : "",
                  //     }}
                  //     aria-controls={`${i}-content`}
                  //     id={`${i}-header`}
                  //   >
                  //     <div style={{ display: "flex", alignItems: "center" }}>
                  //       {type === "queue" && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <PeopleAlt style={{ paddingRight: 10 }} />
                  //           {event[0]?.queueName || "QUEUE"}
                  //         </span>
                  //       )}
                  //       {type === "agent" && (
                  //         <span
                  //           style={{ display: "flex", alignItems: "center" }}
                  //         >
                  //           <Person style={{ paddingRight: 10 }} />
                  //           {event[0]?.username || "AGENT"}
                  //         </span>
                  //       )}
                  //     </div>
                  //   </AccordionSummary>
                  //   <AccordionDetails>
                  //     <div
                  //       style={{
                  //         width: "100%",
                  //         paddingLeft: 30,
                  //         background: mode === "light" ? "white" : "#181d1f",
                  //       }}
                  //     >
                  //       {event?.map((leg) => {
                  //         return (
                  //           <Accordion
                  //             square
                  //             elevation={0}
                  //             className="c2g-device-accordion c2g-inner-accordion c2g-accordion"
                  //             style={{
                  //               background:
                  //                 mode === "light" ? "white" : "#181d1f",
                  //               color: mode === "light" ? "black" : "white",
                  //             }}
                  //           >
                  //             <AccordionSummary
                  //               style={{
                  //                 flexDirection: "row-reverse",
                  //                 background: "#11111105",
                  //               }}
                  //               expandIcon={
                  //                 <ArrowDropDown
                  //                   style={{
                  //                     color:
                  //                       mode === "light" ? "black" : "white",
                  //                   }}
                  //                 />
                  //               }
                  //             >
                  //               event {reasonRenderer(leg.event)}
                  //             </AccordionSummary>
                  //             <AccordionDetails>
                  //               <div style={{ width: "100%", marginLeft: 20 }}>
                  //                 <div className="c2g-rows-box">
                  //                   <p>Time: </p>
                  //                   <p>
                  //                     {new Date(
                  //                       new Date(leg.timeStamp).getTime() +
                  //                         4 * 60 * 60 * 1000
                  //                     ).toLocaleTimeString("en-US", {
                  //                       hour: "numeric",
                  //                       minute: "numeric",
                  //                       second: "numeric",
                  //                       hour12: true,
                  //                     })}
                  //                   </p>
                  //                 </div>
                  //               </div>
                  //             </AccordionDetails>
                  //           </Accordion>
                  //         );
                  //       })}
                  //     </div>
                  //   </AccordionDetails>
                  // </Accordion>
                  <div style={{
                    background: renderCXAccordionScheme(
                      mode,
                     expanded === accordionId
                   ),
                   height: 35,
                   display: 'flex',
                  alignItems: "center",
                   color: mode === "light" ? "black" : "white",
                    borderRadius: 4,
                     }}
                     className={`c2g-device-accordion c2g-outer-accordion c2g-accordion cx-accordion ${expanded === accordionId ? "c2g-accordion-expanded" : ""}`}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                      {type === "queue" && (
                        <>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <PeopleAlt style={{ paddingRight: 10 }} />
                          {event[0]?.queueName || "QUEUE"}
                        </span>
                        </>
                      )}
                      {type === "agent" && (
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <Person style={{ paddingRight: 10 }} />
                          {event[0]?.username || "AGENT"}
                        </span>
                      )}
                    </div>
                </div>
                );
              })}
          </div>
          <div
            className="right-c2g-timeline"
            style={{ width: "100%", overflow: "scroll", position: "relative" }}
          >
            <div
              style={{ position: "absolute", top: 60 }}
              onMouseMove={(e) => handleMouseMove(e, setMouseXCoord)}
            >
              {exTransferFromCx &&
                Array.from(exTransferFromCx.values()).map(
                  (device: CxCallEvent[], j: number) => (
                    <div
                      className="device-box"
                      style={{ position: "relative" }}
                    >
                      {device
                        .sort((a: CxCallEvent, b: CxCallEvent) => {
                          if (a.event === "abandonTime") {
                            return -1;
                          }
                          if (a.event === "disconnectedTime") {
                            return 1;
                          }
                          return 0;
                        })
                        .map((event: any, i: number, array: CxCallEvent[]) => {
                          const nextItem = array[i + 1];
                          const adjustEventDate = (date: string) => {
                            const dateVal = new Date(date as string);
                            const timeZoneOffset =
                              dateVal.getTimezoneOffset() * 60 * 1000;
                            return dateVal.getTime() + timeZoneOffset;
                          };
                          return (
                            <>
                           
                            <span
                            onMouseEnter={() => setExpanded(`${j}-${device[0]?.timeStamp}`)}
                          onMouseLeave={() => setExpanded(false)}
                              className="leg-box cx-leg-box"
                              style={{
                                position: "absolute",
                                transitionDuration: "0.2s",
                                marginLeft: 0,
                                width: nextItem
                                  ? ((Math.floor(
                                      adjustEventDate(
                                        nextItem?.timeStamp as string
                                      )
                                    ) -
                                      Math.floor(
                                        adjustEventDate(event.timeStamp)
                                      )) /
                                      100) *
                                      granularity +
                                    20
                                  : 20,
                                left:
                                  (Math.floor(
                                    adjustEventDate(event?.timeStamp) -
                                      timeStamps[0]
                                  ) *
                                    granularity) /
                                  100,
                                background: renderCXBgStyles(event),
                              }}
                            >
                              <RenderCxLeg
                                index={i}
                                event={event}
                                eventArr={array}
                                cxAgents={cxAgents}
                                mode={mode}
                                setExpanded={setExpanded}
                                deviceId={`${j}-${device[0]?.timeStamp}`}
                              />
                            </span>
                            </>
                          );
                        })}
                    </div>
                  )
                )}
              {Array.from(EXEvents.values()).map(
                (device: CallEvent[], j: number) => (
                  <div className="device-box" style={{ position: "relative" }}>
                    {device.map((leg: CallEvent, i: number) => (
                      <span
                      onMouseEnter={() => setExpanded(`${device[0]?.index}`)}
                          onMouseLeave={() => setExpanded(false)}
                        className="leg-box ex-leg-box"
                        style={{
                          position: "absolute",
                          transitionDuration: "0.2s",
                          marginLeft:
                            device[i] === device[0]
                              ? `calc(${
                                  calculateWidths(
                                    device.map((d) => d.body.eventTime),
                                    device.length,
                                    timeStamps,
                                    granularity
                                  )[i]
                                })`
                              : -0,
                          left: `calc(${
                            calculateWidths(
                              device.map((d) => d.body.eventTime),
                              device.length,
                              timeStamps,
                              granularity
                            )[i]
                          }px)`,
                          width: device[i + 1]
                            ? `calc(${
                                calculateWidths(
                                  device.map((d) => d.body.eventTime),
                                  device.length,
                                  timeStamps,
                                  granularity
                                )[i + 1] -
                                calculateWidths(
                                  device.map((d) => d.body.eventTime),
                                  device.length,
                                  timeStamps,
                                  granularity
                                )[i]
                              }px + 20px)`
                            : 20,
                          background: `${renderBgStyles(leg)}`,
                        }}
                      >
                        <RenderEXLeg
                          hasCX={!!cxAgents}
                          device={device}
                          event={leg}
                          index={i + 1}
                          sequence={sequence}
                          user={historicalUsers.find(
                            (user: any) =>
                              user.id === leg.body.parties[0]?.extensionId
                          )}
                          queue={historicalQueues.find(
                            (queue: any) =>
                              queue.id === leg.body.parties[0]?.queue
                          )}
                          mode={mode}
                          setExpanded={setExpanded}
                          deviceId={device[0].index!}
                        />
                      </span>
                    ))}
                  </div>
                )
              )}
              {exTransferToCx &&
                Array.from(exTransferToCx.values()).map(
                  (device: CxCallEvent[], j: number) => (
                    <div
                      className="device-box"
                      style={{ position: "relative" }}
                    >
                      {device
                        .sort((a: CxCallEvent, b: CxCallEvent) => {
                          if (a.event === "abandonTime") {
                            return -1;
                          }
                          if (a.event === "disconnectedTime") {
                            return 1;
                          }
                          return 0;
                        })
                        .map((event: any, i: number, array: CxCallEvent[]) => {
                          const nextItem = array[i + 1];
                          const adjustEventDate = (date: string) => {
                            const dateVal = new Date(date as string);
                            const timeZoneOffset =
                              dateVal.getTimezoneOffset() * 60 * 1000;
                            return dateVal.getTime() + timeZoneOffset;
                          };
                          return (
                            <>
                          
                            <span
                            onMouseEnter={() => setExpanded(`${j}-${device[0]?.timeStamp}`)}
                          onMouseLeave={() => setExpanded(false)}
                              className="leg-box cx-leg-box"
                              style={{
                                position: "absolute",
                                transitionDuration: "0.2s",
                                marginLeft: 0,
                                width: nextItem
                                  ? ((Math.floor(
                                      adjustEventDate(
                                        nextItem?.timeStamp as string
                                      )
                                    ) -
                                      Math.floor(
                                        adjustEventDate(event.timeStamp)
                                      )) /
                                      100) *
                                      granularity +
                                    20
                                  : 20,
                                left:
                                  (Math.floor(
                                    adjustEventDate(event?.timeStamp) -
                                      timeStamps[0]
                                  ) *
                                    granularity) /
                                  100,
                                background: renderCXBgStyles(event),
                              }}
                            >
                              <RenderCxLeg
                                index={i}
                                event={event}
                                eventArr={array}
                                cxAgents={cxAgents}
                                mode={mode}
                                setExpanded={setExpanded}
                                deviceId={`${j}-${device[0]?.timeStamp}`}
                              />
                            </span>
                            <span
                            onMouseEnter={() => setExpanded(`${j}-${device[0]?.timeStamp}`)}
                          onMouseLeave={() => setExpanded(false)}
                              className="leg-box cx-leg-box"
                              style={{
                                position: "absolute",
                                transitionDuration: "0.2s",
                                marginLeft: 0,
                                width: nextItem
                                  ? ((Math.floor(
                                      adjustEventDate(
                                        nextItem?.timeStamp as string
                                      )
                                    ) -
                                      Math.floor(
                                        adjustEventDate(event.timeStamp)
                                      )) /
                                      100) *
                                      granularity +
                                    20
                                  : 20,
                                left:
                                  (Math.floor(
                                    adjustEventDate(event?.timeStamp) -
                                      timeStamps[0]
                                  ) *
                                    granularity) /
                                  100,
                                background: renderCXBgStyles(event),
                              }}
                            >
                              <RenderCxLeg
                                index={i}
                                event={event}
                                eventArr={array}
                                cxAgents={cxAgents}
                                mode={mode}
                                setExpanded={setExpanded}
                                deviceId={`${j}-${device[0]?.timeStamp}`}
                              />
                            </span>
                            </>
                          );
                        })}
                    </div>
                  )
                )}
            </div>
            <div
              onMouseLeave={handleMouseLeave}
              onMouseMove={(e) => handleMouseMove(e, setMouseXCoord)}
              className={`background-grid ${
                mode === "light" ? "light-grid" : "dark-grid"
              } ${mouseCoords ? "in-focus" : ""}`}
              style={{
                width:
                  exTransferToCx && exTransferToCx.size > 0
                    ? ((timeStamps[1] -
                        timeStamps[0] +
                        (new Date(
                          Array.from(exTransferToCx?.values())?.at(-1)?.at(-1)
                            ?.timeStamp || new Date()
                        )?.getTime() +
                          new Date(
                            Array.from(exTransferToCx?.values())?.at(-1)?.at(-1)
                              ?.timeStamp || new Date()
                          )?.getTimezoneOffset() *
                            60000 -
                          timeStamps[1])) /
                        100 +
                        50) *
                      granularity
                    : ((timeStamps[1] - timeStamps[0]) / 100 + 50) *
                      granularity,
                minWidth: "100%",
              }}
            >
              <div style={{
                position: 'absolute',
                width:((timeStamps[1] - timeStamps[0]) / 100 + 50) * granularity,
                minWidth: "100%", 
                top: 0,
                height: '100%',
                marginTop: -20,
                }} 
                className={`top-grid ${mode === "light" ? "top-light-grid" : "top-dark-grid"}`}/>
              <MouseIndicator />
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  height: 40,
                  marginTop: -20,
                  overflow: "visible",
                  // borderBottom: mode === 'light' ? "2px solid #555" : "2px solid #99999933"
                }}
              >
                <div style={{width: '100%', zIndex: 2, background: mode === 'light' ? "white" : '#191919', borderBottom: mode === 'light' ? "2px solid #ccc" : '2px solid #444', height: 40}}>
                <HandlePlatformTransferLabels
                  timeStamps={timeStamps}
                  EXEvents={EXEvents}
                  CXEvents={CXEvents}
                  cxTransfersFromEx={cxTransfersFromEx}
                  cxTransfersToEx={cxTransfersToEx}
                  exTransferFromCx={exTransferFromCx}
                  exTransferToCx={exTransferToCx}
                  granularity={granularity}
                  mode={mode}
                />
                </div>
                {getTimeIncrements(
                  timeStamps[0],
                  timeStamps[1] + 300000,
                  mode,
                  granularity,
                  !!mouseCoords
                )}
                {mouseCoords &&
                  renderTimeOnHover(mouseCoords, granularity, mode)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default C2GTimeline;
